import { Fragment as ge, reactive as le, computed as g, watchEffect as Te, toRefs as Ca, capitalize as ot, shallowRef as H, warn as mn, getCurrentInstance as Di, ref as j, unref as X, provide as he, inject as oe, defineComponent as we, camelize as pa, h as je, onBeforeUnmount as be, watch as R, readonly as Pt, onDeactivated as Sa, onActivated as Fi, onMounted as st, createVNode as d, isRef as ze, onScopeDispose as se, effectScope as gn, toRaw as La, Transition as Ae, openBlock as U, createBlock as ee, withCtx as B, createElementVNode as De, createElementBlock as et, createCommentVNode as Qe, toDisplayString as Pe, mergeProps as Z, toRef as Y, Text as zi, TransitionGroup as Tt, onBeforeMount as ji, nextTick as Ie, withDirectives as tt, resolveDirective as yn, vShow as wa, resolveDynamicComponent as Wi, renderList as xa, normalizeStyle as Ui, createTextVNode as Ne, onUpdated as Zi, Teleport as Gi, renderSlot as me } from "vue";
import { createVuetify as qi } from "vuetify";
import { mdiChevronUp as Yi, mdiChevronDown as Ki, mdiHome as Xi, mdiCog as Ji, mdiAccount as gt, mdiLogout as Qi, mdiDotsGrid as el, mdiMagnify as tl, mdiRefresh as nl, mdiPhone as al, mdiPencil as il, mdiPlus as ll, mdiClose as Wt, mdiEmail as rl, mdiDelete as ol, mdiHistory as sl, mdiCalendar as ul, mdiAccountGroup as yt, mdiHeadset as cl, mdiPalette as Tn, mdiChartLine as dl, mdiMapMarker as fl, mdiFileDocument as vl, mdiFileDocumentMultiple as ml, mdiClipboard as gl, mdiDeleteClock as yl, mdiFormatListText as hl, mdiTag as bl, mdiTagMultiple as Cl, mdiTextBox as pl, mdiTicketOutline as Sl, mdiAccountMultiple as Ll, mdiProgressCheck as wl, mdiInformation as xl, mdiCheck as In, mdiAlert as On, mdiCancel as kl, mdiCodeBraces as _l, mdiTestTubeEmpty as Vl, mdiTestTube as El, mdiCheckCircle as Al, mdiWeatherSunny as Pl, mdiWeatherNight as Tl, mdiAlertCircleOutline as Il, mdiAccountHardHat as Ol, mdiHeartPlus as Bl, mdiWall as Ml, mdiAccountReactivate as $l, mdiWrench as Nl, mdiShieldAlert as Rl } from "@mdi/js";
function k(e, n) {
  return (t) => Object.keys(e).reduce((a, i) => {
    const r = typeof e[i] == "object" && e[i] != null && !Array.isArray(e[i]) ? e[i] : {
      type: e[i]
    };
    return t && i in t ? a[i] = {
      ...r,
      default: t[i]
    } : a[i] = r, n && !a[i].source && (a[i].source = n), a;
  }, {});
}
const z = k({
  class: [String, Array, Object],
  style: {
    type: [String, Array, Object],
    default: null
  }
}, "component"), Q = typeof window < "u", hn = Q && "IntersectionObserver" in window;
function bn(e, n) {
  if (e === n) return !0;
  if (e instanceof Date && n instanceof Date && e.getTime() !== n.getTime() || e !== Object(e) || n !== Object(n))
    return !1;
  const t = Object.keys(e);
  return t.length !== Object.keys(n).length ? !1 : t.every((a) => bn(e[a], n[a]));
}
function T(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "px";
  if (!(e == null || e === ""))
    return isNaN(+e) ? String(e) : isFinite(+e) ? `${Number(e)}${n}` : void 0;
}
function Hl(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e);
}
function Bn(e) {
  let n;
  return e !== null && typeof e == "object" && ((n = Object.getPrototypeOf(e)) === Object.prototype || n === null);
}
function Dl(e) {
  if (e && "$el" in e) {
    const n = e.$el;
    return (n == null ? void 0 : n.nodeType) === Node.TEXT_NODE ? n.nextElementSibling : n;
  }
  return e;
}
const Mn = Object.freeze({
  enter: 13,
  tab: 9,
  delete: 46,
  esc: 27,
  space: 32,
  up: 38,
  down: 40,
  left: 37,
  right: 39,
  end: 35,
  home: 36,
  del: 46,
  backspace: 8,
  insert: 45,
  pageup: 33,
  pagedown: 34,
  shift: 16
});
function Ut(e, n) {
  return n.every((t) => e.hasOwnProperty(t));
}
function Fl(e, n) {
  const t = {}, a = new Set(Object.keys(e));
  for (const i of n)
    a.has(i) && (t[i] = e[i]);
  return t;
}
function zl(e, n) {
  const t = {
    ...e
  };
  return n.forEach((a) => delete t[a]), t;
}
const jl = /^on[^a-z]/, ka = (e) => jl.test(e);
function Wl(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function nt(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
  return Math.max(n, Math.min(t, e));
}
function $n(e, n) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0";
  return e + t.repeat(Math.max(0, n - e.length));
}
function Ul(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  const t = [];
  let a = 0;
  for (; a < e.length; )
    t.push(e.substr(a, n)), a += n;
  return t;
}
function Re() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = arguments.length > 2 ? arguments[2] : void 0;
  const a = {};
  for (const i in e)
    a[i] = e[i];
  for (const i in n) {
    const l = e[i], r = n[i];
    if (Bn(l) && Bn(r)) {
      a[i] = Re(l, r, t);
      continue;
    }
    if (t && Array.isArray(l) && Array.isArray(r)) {
      a[i] = t(l, r);
      continue;
    }
    a[i] = r;
  }
  return a;
}
function _a(e) {
  return e.map((n) => n.type === ge ? _a(n.children) : n).flat();
}
function _e() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  if (_e.cache.has(e)) return _e.cache.get(e);
  const n = e.replace(/[^a-z]/gi, "-").replace(/\B([A-Z])/g, "-$1").toLowerCase();
  return _e.cache.set(e, n), n;
}
_e.cache = /* @__PURE__ */ new Map();
function He(e, n) {
  if (!n || typeof n != "object") return [];
  if (Array.isArray(n))
    return n.map((t) => He(e, t)).flat(1);
  if (n.suspense)
    return He(e, n.ssContent);
  if (Array.isArray(n.children))
    return n.children.map((t) => He(e, t)).flat(1);
  if (n.component) {
    if (Object.getOwnPropertySymbols(n.component.provides).includes(e))
      return [n.component];
    if (n.component.subTree)
      return He(e, n.component.subTree).flat(1);
  }
  return [];
}
function Cn(e) {
  const n = le({}), t = g(e);
  return Te(() => {
    for (const a in t.value)
      n[a] = t.value[a];
  }, {
    flush: "sync"
  }), Ca(n);
}
function wt(e, n) {
  return e.includes(n);
}
function Va(e) {
  return e[2].toLowerCase() + e.slice(3);
}
function Nn(e, n) {
  return n = "on" + ot(n), !!(e[n] || e[`${n}Once`] || e[`${n}Capture`] || e[`${n}OnceCapture`] || e[`${n}CaptureOnce`]);
}
function tn(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  const t = ["button", "[href]", 'input:not([type="hidden"])', "select", "textarea", "[tabindex]"].map((a) => `${a}${n ? ':not([tabindex="-1"])' : ""}:not([disabled])`).join(", ");
  return [...e.querySelectorAll(t)];
}
function Ea(e, n, t) {
  let a, i = e.indexOf(document.activeElement);
  const l = n === "next" ? 1 : -1;
  do
    i += l, a = e[i];
  while ((!a || a.offsetParent == null || !((t == null ? void 0 : t(a)) ?? !0)) && i < e.length && i >= 0);
  return a;
}
function Ct(e, n) {
  var a, i, l, r;
  const t = tn(e);
  if (!n)
    (e === document.activeElement || !e.contains(document.activeElement)) && ((a = t[0]) == null || a.focus());
  else if (n === "first")
    (i = t[0]) == null || i.focus();
  else if (n === "last")
    (l = t.at(-1)) == null || l.focus();
  else if (typeof n == "number")
    (r = t[n]) == null || r.focus();
  else {
    const o = Ea(t, n);
    o ? o.focus() : Ct(e, n === "next" ? "first" : "last");
  }
}
function Zl(e, n) {
  if (!(Q && typeof CSS < "u" && typeof CSS.supports < "u" && CSS.supports(`selector(${n})`))) return null;
  try {
    return !!e && e.matches(n);
  } catch {
    return null;
  }
}
function Gl(e, n) {
  if (!Q || e === 0)
    return n(), () => {
    };
  const t = window.setTimeout(n, e);
  return () => window.clearTimeout(t);
}
function ql(e, n) {
  const t = e.clientX, a = e.clientY, i = n.getBoundingClientRect(), l = i.left, r = i.top, o = i.right, s = i.bottom;
  return t >= l && t <= o && a >= r && a <= s;
}
function nn() {
  const e = H(), n = (t) => {
    e.value = t;
  };
  return Object.defineProperty(n, "value", {
    enumerable: !0,
    get: () => e.value,
    set: (t) => e.value = t
  }), Object.defineProperty(n, "el", {
    enumerable: !0,
    get: () => Dl(e.value)
  }), n;
}
const Aa = ["top", "bottom"], Yl = ["start", "end", "left", "right"];
function an(e, n) {
  let [t, a] = e.split(" ");
  return a || (a = wt(Aa, t) ? "start" : wt(Yl, t) ? "top" : "center"), {
    side: Rn(t, n),
    align: Rn(a, n)
  };
}
function Rn(e, n) {
  return e === "start" ? n ? "right" : "left" : e === "end" ? n ? "left" : "right" : e;
}
function Zt(e) {
  return {
    side: {
      center: "center",
      top: "bottom",
      bottom: "top",
      left: "right",
      right: "left"
    }[e.side],
    align: e.align
  };
}
function Gt(e) {
  return {
    side: e.side,
    align: {
      center: "center",
      top: "bottom",
      bottom: "top",
      left: "right",
      right: "left"
    }[e.align]
  };
}
function Hn(e) {
  return {
    side: e.align,
    align: e.side
  };
}
function Dn(e) {
  return wt(Aa, e.side) ? "y" : "x";
}
class Ve {
  constructor(n) {
    let {
      x: t,
      y: a,
      width: i,
      height: l
    } = n;
    this.x = t, this.y = a, this.width = i, this.height = l;
  }
  get top() {
    return this.y;
  }
  get bottom() {
    return this.y + this.height;
  }
  get left() {
    return this.x;
  }
  get right() {
    return this.x + this.width;
  }
}
function Fn(e, n) {
  return {
    x: {
      before: Math.max(0, n.left - e.left),
      after: Math.max(0, e.right - n.right)
    },
    y: {
      before: Math.max(0, n.top - e.top),
      after: Math.max(0, e.bottom - n.bottom)
    }
  };
}
function Pa(e) {
  return Array.isArray(e) ? new Ve({
    x: e[0],
    y: e[1],
    width: 0,
    height: 0
  }) : e.getBoundingClientRect();
}
function Ta(e) {
  const n = e.getBoundingClientRect(), t = getComputedStyle(e), a = t.transform;
  if (a) {
    let i, l, r, o, s;
    if (a.startsWith("matrix3d("))
      i = a.slice(9, -1).split(/, /), l = +i[0], r = +i[5], o = +i[12], s = +i[13];
    else if (a.startsWith("matrix("))
      i = a.slice(7, -1).split(/, /), l = +i[0], r = +i[3], o = +i[4], s = +i[5];
    else
      return new Ve(n);
    const u = t.transformOrigin, c = n.x - o - (1 - l) * parseFloat(u), f = n.y - s - (1 - r) * parseFloat(u.slice(u.indexOf(" ") + 1)), v = l ? n.width / l : e.offsetWidth + 1, m = r ? n.height / r : e.offsetHeight + 1;
    return new Ve({
      x: c,
      y: f,
      width: v,
      height: m
    });
  } else
    return new Ve(n);
}
function Ke(e, n, t) {
  if (typeof e.animate > "u") return {
    finished: Promise.resolve()
  };
  let a;
  try {
    a = e.animate(n, t);
  } catch {
    return {
      finished: Promise.resolve()
    };
  }
  return typeof a.finished > "u" && (a.finished = new Promise((i) => {
    a.onfinish = () => {
      i(a);
    };
  })), a;
}
const pt = /* @__PURE__ */ new WeakMap();
function Kl(e, n) {
  Object.keys(n).forEach((t) => {
    if (ka(t)) {
      const a = Va(t), i = pt.get(e);
      if (n[t] == null)
        i == null || i.forEach((l) => {
          const [r, o] = l;
          r === a && (e.removeEventListener(a, o), i.delete(l));
        });
      else if (!i || ![...i].some((l) => l[0] === a && l[1] === n[t])) {
        e.addEventListener(a, n[t]);
        const l = i || /* @__PURE__ */ new Set();
        l.add([a, n[t]]), pt.has(e) || pt.set(e, l);
      }
    } else
      n[t] == null ? e.removeAttribute(t) : e.setAttribute(t, n[t]);
  });
}
function Xl(e, n) {
  Object.keys(n).forEach((t) => {
    if (ka(t)) {
      const a = Va(t), i = pt.get(e);
      i == null || i.forEach((l) => {
        const [r, o] = l;
        r === a && (e.removeEventListener(a, o), i.delete(l));
      });
    } else
      e.removeAttribute(t);
  });
}
const $e = 2.4, zn = 0.2126729, jn = 0.7151522, Wn = 0.072175, Jl = 0.55, Ql = 0.58, er = 0.57, tr = 0.62, ht = 0.03, Un = 1.45, nr = 5e-4, ar = 1.25, ir = 1.25, Zn = 0.078, Gn = 12.82051282051282, bt = 0.06, qn = 1e-3;
function Yn(e, n) {
  const t = (e.r / 255) ** $e, a = (e.g / 255) ** $e, i = (e.b / 255) ** $e, l = (n.r / 255) ** $e, r = (n.g / 255) ** $e, o = (n.b / 255) ** $e;
  let s = t * zn + a * jn + i * Wn, u = l * zn + r * jn + o * Wn;
  if (s <= ht && (s += (ht - s) ** Un), u <= ht && (u += (ht - u) ** Un), Math.abs(u - s) < nr) return 0;
  let c;
  if (u > s) {
    const f = (u ** Jl - s ** Ql) * ar;
    c = f < qn ? 0 : f < Zn ? f - f * Gn * bt : f - bt;
  } else {
    const f = (u ** tr - s ** er) * ir;
    c = f > -qn ? 0 : f > -Zn ? f - f * Gn * bt : f + bt;
  }
  return c * 100;
}
function Ee(e) {
  mn(`Vuetify: ${e}`);
}
function lr(e) {
  mn(`Vuetify error: ${e}`);
}
function ln(e) {
  return !!e && /^(#|var\(--|(rgb|hsl)a?\()/.test(e);
}
function rr(e) {
  return ln(e) && !/^((rgb|hsl)a?\()?var\(--/.test(e);
}
const Kn = /^(?<fn>(?:rgb|hsl)a?)\((?<values>.+)\)/, or = {
  rgb: (e, n, t, a) => ({
    r: e,
    g: n,
    b: t,
    a
  }),
  rgba: (e, n, t, a) => ({
    r: e,
    g: n,
    b: t,
    a
  }),
  hsl: (e, n, t, a) => Xn({
    h: e,
    s: n,
    l: t,
    a
  }),
  hsla: (e, n, t, a) => Xn({
    h: e,
    s: n,
    l: t,
    a
  }),
  hsv: (e, n, t, a) => at({
    h: e,
    s: n,
    v: t,
    a
  }),
  hsva: (e, n, t, a) => at({
    h: e,
    s: n,
    v: t,
    a
  })
};
function Xe(e) {
  if (typeof e == "number")
    return (isNaN(e) || e < 0 || e > 16777215) && Ee(`'${e}' is not a valid hex color`), {
      r: (e & 16711680) >> 16,
      g: (e & 65280) >> 8,
      b: e & 255
    };
  if (typeof e == "string" && Kn.test(e)) {
    const {
      groups: n
    } = e.match(Kn), {
      fn: t,
      values: a
    } = n, i = a.split(/,\s*/).map((l) => l.endsWith("%") && ["hsl", "hsla", "hsv", "hsva"].includes(t) ? parseFloat(l) / 100 : parseFloat(l));
    return or[t](...i);
  } else if (typeof e == "string") {
    let n = e.startsWith("#") ? e.slice(1) : e;
    [3, 4].includes(n.length) ? n = n.split("").map((a) => a + a).join("") : [6, 8].includes(n.length) || Ee(`'${e}' is not a valid hex(a) color`);
    const t = parseInt(n, 16);
    return (isNaN(t) || t < 0 || t > 4294967295) && Ee(`'${e}' is not a valid hex(a) color`), sr(n);
  } else if (typeof e == "object") {
    if (Ut(e, ["r", "g", "b"]))
      return e;
    if (Ut(e, ["h", "s", "l"]))
      return at(Ia(e));
    if (Ut(e, ["h", "s", "v"]))
      return at(e);
  }
  throw new TypeError(`Invalid color: ${e == null ? e : String(e) || e.constructor.name}
Expected #hex, #hexa, rgb(), rgba(), hsl(), hsla(), object or number`);
}
function at(e) {
  const {
    h: n,
    s: t,
    v: a,
    a: i
  } = e, l = (o) => {
    const s = (o + n / 60) % 6;
    return a - a * t * Math.max(Math.min(s, 4 - s, 1), 0);
  }, r = [l(5), l(3), l(1)].map((o) => Math.round(o * 255));
  return {
    r: r[0],
    g: r[1],
    b: r[2],
    a: i
  };
}
function Xn(e) {
  return at(Ia(e));
}
function Ia(e) {
  const {
    h: n,
    s: t,
    l: a,
    a: i
  } = e, l = a + t * Math.min(a, 1 - a), r = l === 0 ? 0 : 2 - 2 * a / l;
  return {
    h: n,
    s: r,
    v: l,
    a: i
  };
}
function sr(e) {
  e = ur(e);
  let [n, t, a, i] = Ul(e, 2).map((l) => parseInt(l, 16));
  return i = i === void 0 ? i : i / 255, {
    r: n,
    g: t,
    b: a,
    a: i
  };
}
function ur(e) {
  return e.startsWith("#") && (e = e.slice(1)), e = e.replace(/([^0-9a-f])/gi, "F"), (e.length === 3 || e.length === 4) && (e = e.split("").map((n) => n + n).join("")), e.length !== 6 && (e = $n($n(e, 6), 8, "F")), e;
}
function cr(e) {
  const n = Math.abs(Yn(Xe(0), Xe(e)));
  return Math.abs(Yn(Xe(16777215), Xe(e))) > Math.min(n, 50) ? "#fff" : "#000";
}
function G(e, n) {
  const t = Di();
  if (!t)
    throw new Error(`[Vuetify] ${e} must be called from inside a setup function`);
  return t;
}
function xe() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "composables";
  const n = G(e).type;
  return _e((n == null ? void 0 : n.aliasName) || (n == null ? void 0 : n.name));
}
let Oa = 0, St = /* @__PURE__ */ new WeakMap();
function It() {
  const e = G("getUid");
  if (St.has(e)) return St.get(e);
  {
    const n = Oa++;
    return St.set(e, n), n;
  }
}
It.reset = () => {
  Oa = 0, St = /* @__PURE__ */ new WeakMap();
};
function dr(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : G("injectSelf");
  const {
    provides: t
  } = n;
  if (t && e in t)
    return t[e];
}
const xt = Symbol.for("vuetify:defaults");
function pn() {
  const e = oe(xt);
  if (!e) throw new Error("[Vuetify] Could not find defaults instance");
  return e;
}
function Ot(e, n) {
  const t = pn(), a = j(e), i = g(() => {
    if (X(n == null ? void 0 : n.disabled)) return t.value;
    const r = X(n == null ? void 0 : n.scoped), o = X(n == null ? void 0 : n.reset), s = X(n == null ? void 0 : n.root);
    if (a.value == null && !(r || o || s)) return t.value;
    let u = Re(a.value, {
      prev: t.value
    });
    if (r) return u;
    if (o || s) {
      const c = Number(o || 1 / 0);
      for (let f = 0; f <= c && !(!u || !("prev" in u)); f++)
        u = u.prev;
      return u && typeof s == "string" && s in u && (u = Re(Re(u, {
        prev: u
      }), u[s])), u;
    }
    return u.prev ? Re(u.prev, u) : u;
  });
  return he(xt, i), i;
}
function fr(e, n) {
  var t, a;
  return typeof ((t = e.props) == null ? void 0 : t[n]) < "u" || typeof ((a = e.props) == null ? void 0 : a[_e(n)]) < "u";
}
function vr() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0, t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : pn();
  const a = G("useDefaults");
  if (n = n ?? a.type.name ?? a.type.__name, !n)
    throw new Error("[Vuetify] Could not determine component name");
  const i = g(() => {
    var s;
    return (s = t.value) == null ? void 0 : s[e._as ?? n];
  }), l = new Proxy(e, {
    get(s, u) {
      var f, v, m, b, y, h, L;
      const c = Reflect.get(s, u);
      return u === "class" || u === "style" ? [(f = i.value) == null ? void 0 : f[u], c].filter((p) => p != null) : typeof u == "string" && !fr(a.vnode, u) ? ((v = i.value) == null ? void 0 : v[u]) !== void 0 ? (m = i.value) == null ? void 0 : m[u] : ((y = (b = t.value) == null ? void 0 : b.global) == null ? void 0 : y[u]) !== void 0 ? (L = (h = t.value) == null ? void 0 : h.global) == null ? void 0 : L[u] : c : c;
    }
  }), r = H();
  Te(() => {
    if (i.value) {
      const s = Object.entries(i.value).filter((u) => {
        let [c] = u;
        return c.startsWith(c[0].toUpperCase());
      });
      r.value = s.length ? Object.fromEntries(s) : void 0;
    } else
      r.value = void 0;
  });
  function o() {
    const s = dr(xt, a);
    he(xt, g(() => r.value ? Re((s == null ? void 0 : s.value) ?? {}, r.value) : s == null ? void 0 : s.value));
  }
  return {
    props: l,
    provideSubDefaults: o
  };
}
function Bt(e) {
  if (e._setup = e._setup ?? e.setup, !e.name)
    return Ee("The component is missing an explicit name, unable to generate default prop value"), e;
  if (e._setup) {
    e.props = k(e.props ?? {}, e.name)();
    const n = Object.keys(e.props).filter((t) => t !== "class" && t !== "style");
    e.filterProps = function(a) {
      return Fl(a, n);
    }, e.props._as = String, e.setup = function(a, i) {
      const l = pn();
      if (!l.value) return e._setup(a, i);
      const {
        props: r,
        provideSubDefaults: o
      } = vr(a, a._as ?? e.name, l), s = e._setup(r, i);
      return o(), s;
    };
  }
  return e;
}
function M() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
  return (n) => (e ? Bt : we)(n);
}
function Ba(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "div", t = arguments.length > 2 ? arguments[2] : void 0;
  return M()({
    name: t ?? ot(pa(e.replace(/__/g, "-"))),
    props: {
      tag: {
        type: String,
        default: n
      },
      ...z()
    },
    setup(a, i) {
      let {
        slots: l
      } = i;
      return () => {
        var r;
        return je(a.tag, {
          class: [e, a.class],
          style: a.style
        }, (r = l.default) == null ? void 0 : r.call(l));
      };
    }
  });
}
function Ma(e) {
  if (typeof e.getRootNode != "function") {
    for (; e.parentNode; ) e = e.parentNode;
    return e !== document ? null : document;
  }
  const n = e.getRootNode();
  return n !== document && n.getRootNode({
    composed: !0
  }) !== document ? null : n;
}
const rn = "cubic-bezier(0.4, 0, 0.2, 1)", mr = "cubic-bezier(0.0, 0, 0.2, 1)", gr = "cubic-bezier(0.4, 0, 1, 1)";
function yr(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  for (; e; ) {
    if (n ? hr(e) : Sn(e)) return e;
    e = e.parentElement;
  }
  return document.scrollingElement;
}
function kt(e, n) {
  const t = [];
  if (n && e && !n.contains(e)) return t;
  for (; e && (Sn(e) && t.push(e), e !== n); )
    e = e.parentElement;
  return t;
}
function Sn(e) {
  if (!e || e.nodeType !== Node.ELEMENT_NODE) return !1;
  const n = window.getComputedStyle(e);
  return n.overflowY === "scroll" || n.overflowY === "auto" && e.scrollHeight > e.clientHeight;
}
function hr(e) {
  if (!e || e.nodeType !== Node.ELEMENT_NODE) return !1;
  const n = window.getComputedStyle(e);
  return ["scroll", "auto"].includes(n.overflowY);
}
function br(e) {
  for (; e; ) {
    if (window.getComputedStyle(e).position === "fixed")
      return !0;
    e = e.offsetParent;
  }
  return !1;
}
function D(e) {
  const n = G("useRender");
  n.render = e;
}
const We = k({
  height: [Number, String],
  maxHeight: [Number, String],
  maxWidth: [Number, String],
  minHeight: [Number, String],
  minWidth: [Number, String],
  width: [Number, String]
}, "dimension");
function Ue(e) {
  return {
    dimensionStyles: g(() => {
      const t = {}, a = T(e.height), i = T(e.maxHeight), l = T(e.maxWidth), r = T(e.minHeight), o = T(e.minWidth), s = T(e.width);
      return a != null && (t.height = a), i != null && (t.maxHeight = i), l != null && (t.maxWidth = l), r != null && (t.minHeight = r), o != null && (t.minWidth = o), s != null && (t.width = s), t;
    })
  };
}
function $a(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "content";
  const t = nn(), a = j();
  if (Q) {
    const i = new ResizeObserver((l) => {
      l.length && (n === "content" ? a.value = l[0].contentRect : a.value = l[0].target.getBoundingClientRect());
    });
    be(() => {
      i.disconnect();
    }), R(() => t.el, (l, r) => {
      r && (i.unobserve(r), a.value = void 0), l && i.observe(l);
    }, {
      flush: "post"
    });
  }
  return {
    resizeRef: t,
    contentRect: Pt(a)
  };
}
const on = Symbol.for("vuetify:layout"), Na = Symbol.for("vuetify:layout-item"), Jn = 1e3, Cr = k({
  overlaps: {
    type: Array,
    default: () => []
  },
  fullHeight: Boolean
}, "layout"), pr = k({
  name: {
    type: String
  },
  order: {
    type: [Number, String],
    default: 0
  },
  absolute: Boolean
}, "layout-item");
function Sr(e) {
  const n = oe(on);
  if (!n) throw new Error("[Vuetify] Could not find injected layout");
  const t = e.id ?? `layout-item-${It()}`, a = G("useLayoutItem");
  he(Na, {
    id: t
  });
  const i = H(!1);
  Sa(() => i.value = !0), Fi(() => i.value = !1);
  const {
    layoutItemStyles: l,
    layoutItemScrimStyles: r
  } = n.register(a, {
    ...e,
    active: g(() => i.value ? !1 : e.active.value),
    id: t
  });
  return be(() => n.unregister(t)), {
    layoutItemStyles: l,
    layoutRect: n.layoutRect,
    layoutItemScrimStyles: r
  };
}
const Lr = (e, n, t, a) => {
  let i = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  };
  const l = [{
    id: "",
    layer: {
      ...i
    }
  }];
  for (const r of e) {
    const o = n.get(r), s = t.get(r), u = a.get(r);
    if (!o || !s || !u) continue;
    const c = {
      ...i,
      [o.value]: parseInt(i[o.value], 10) + (u.value ? parseInt(s.value, 10) : 0)
    };
    l.push({
      id: r,
      layer: c
    }), i = c;
  }
  return l;
};
function wr(e) {
  const n = oe(on, null), t = g(() => n ? n.rootZIndex.value - 100 : Jn), a = j([]), i = le(/* @__PURE__ */ new Map()), l = le(/* @__PURE__ */ new Map()), r = le(/* @__PURE__ */ new Map()), o = le(/* @__PURE__ */ new Map()), s = le(/* @__PURE__ */ new Map()), {
    resizeRef: u,
    contentRect: c
  } = $a(), f = g(() => {
    const E = /* @__PURE__ */ new Map(), A = e.overlaps ?? [];
    for (const C of A.filter((I) => I.includes(":"))) {
      const [I, $] = C.split(":");
      if (!a.value.includes(I) || !a.value.includes($)) continue;
      const V = i.get(I), S = i.get($), w = l.get(I), P = l.get($);
      !V || !S || !w || !P || (E.set($, {
        position: V.value,
        amount: parseInt(w.value, 10)
      }), E.set(I, {
        position: S.value,
        amount: -parseInt(P.value, 10)
      }));
    }
    return E;
  }), v = g(() => {
    const E = [...new Set([...r.values()].map((C) => C.value))].sort((C, I) => C - I), A = [];
    for (const C of E) {
      const I = a.value.filter(($) => {
        var V;
        return ((V = r.get($)) == null ? void 0 : V.value) === C;
      });
      A.push(...I);
    }
    return Lr(A, i, l, o);
  }), m = g(() => !Array.from(s.values()).some((E) => E.value)), b = g(() => v.value[v.value.length - 1].layer), y = g(() => ({
    "--v-layout-left": T(b.value.left),
    "--v-layout-right": T(b.value.right),
    "--v-layout-top": T(b.value.top),
    "--v-layout-bottom": T(b.value.bottom),
    ...m.value ? void 0 : {
      transition: "none"
    }
  })), h = g(() => v.value.slice(1).map((E, A) => {
    let {
      id: C
    } = E;
    const {
      layer: I
    } = v.value[A], $ = l.get(C), V = i.get(C);
    return {
      id: C,
      ...I,
      size: Number($.value),
      position: V.value
    };
  })), L = (E) => h.value.find((A) => A.id === E), p = G("createLayout"), x = H(!1);
  st(() => {
    x.value = !0;
  }), he(on, {
    register: (E, A) => {
      let {
        id: C,
        order: I,
        position: $,
        layoutSize: V,
        elementSize: S,
        active: w,
        disableTransitions: P,
        absolute: F
      } = A;
      r.set(C, I), i.set(C, $), l.set(C, V), o.set(C, w), P && s.set(C, P);
      const ve = He(Na, p == null ? void 0 : p.vnode).indexOf(E);
      ve > -1 ? a.value.splice(ve, 0, C) : a.value.push(C);
      const q = g(() => h.value.findIndex((Se) => Se.id === C)), ie = g(() => t.value + v.value.length * 2 - q.value * 2), Ce = g(() => {
        const Se = $.value === "left" || $.value === "right", Le = $.value === "right", jt = $.value === "bottom", qe = S.value ?? V.value, N = qe === 0 ? "%" : "px", J = {
          [$.value]: 0,
          zIndex: ie.value,
          transform: `translate${Se ? "X" : "Y"}(${(w.value ? 0 : -(qe === 0 ? 100 : qe)) * (Le || jt ? -1 : 1)}${N})`,
          position: F.value || t.value !== Jn ? "absolute" : "fixed",
          ...m.value ? void 0 : {
            transition: "none"
          }
        };
        if (!x.value) return J;
        const K = h.value[q.value];
        if (!K) throw new Error(`[Vuetify] Could not find layout item "${C}"`);
        const Me = f.value.get(C);
        return Me && (K[Me.position] += Me.amount), {
          ...J,
          height: Se ? `calc(100% - ${K.top}px - ${K.bottom}px)` : S.value ? `${S.value}px` : void 0,
          left: Le ? void 0 : `${K.left}px`,
          right: Le ? `${K.right}px` : void 0,
          top: $.value !== "bottom" ? `${K.top}px` : void 0,
          bottom: $.value !== "top" ? `${K.bottom}px` : void 0,
          width: Se ? S.value ? `${S.value}px` : void 0 : `calc(100% - ${K.left}px - ${K.right}px)`
        };
      }), pe = g(() => ({
        zIndex: ie.value - 1
      }));
      return {
        layoutItemStyles: Ce,
        layoutItemScrimStyles: pe,
        zIndex: ie
      };
    },
    unregister: (E) => {
      r.delete(E), i.delete(E), l.delete(E), o.delete(E), s.delete(E), a.value = a.value.filter((A) => A !== E);
    },
    mainRect: b,
    mainStyles: y,
    getLayoutItem: L,
    items: h,
    layoutRect: c,
    rootZIndex: t
  });
  const _ = g(() => ["v-layout", {
    "v-layout--full-height": e.fullHeight
  }]), O = g(() => ({
    zIndex: n ? t.value : void 0,
    position: n ? "relative" : void 0,
    overflow: n ? "hidden" : void 0
  }));
  return {
    layoutClasses: _,
    layoutStyles: O,
    getLayoutItem: L,
    items: h,
    layoutRect: c,
    layoutRef: u
  };
}
const xr = k({
  ...z(),
  ...We(),
  ...Cr()
}, "VLayout"), kr = M()({
  name: "VLayout",
  props: xr(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    const {
      layoutClasses: a,
      layoutStyles: i,
      getLayoutItem: l,
      items: r,
      layoutRef: o
    } = wr(e), {
      dimensionStyles: s
    } = Ue(e);
    return D(() => {
      var u;
      return d("div", {
        ref: o,
        class: [a.value, e.class],
        style: [s.value, i.value, e.style]
      }, [(u = t.default) == null ? void 0 : u.call(t)]);
    }), {
      getLayoutItem: l,
      items: r
    };
  }
});
function Ln(e) {
  return Cn(() => {
    const n = [], t = {};
    if (e.value.background)
      if (ln(e.value.background)) {
        if (t.backgroundColor = e.value.background, !e.value.text && rr(e.value.background)) {
          const a = Xe(e.value.background);
          if (a.a == null || a.a === 1) {
            const i = cr(a);
            t.color = i, t.caretColor = i;
          }
        }
      } else
        n.push(`bg-${e.value.background}`);
    return e.value.text && (ln(e.value.text) ? (t.color = e.value.text, t.caretColor = e.value.text) : n.push(`text-${e.value.text}`)), {
      colorClasses: n,
      colorStyles: t
    };
  });
}
function it(e, n) {
  const t = g(() => ({
    text: ze(e) ? e.value : n ? e[n] : null
  })), {
    colorClasses: a,
    colorStyles: i
  } = Ln(t);
  return {
    textColorClasses: a,
    textColorStyles: i
  };
}
function Fe(e, n) {
  const t = g(() => ({
    background: ze(e) ? e.value : n ? e[n] : null
  })), {
    colorClasses: a,
    colorStyles: i
  } = Ln(t);
  return {
    backgroundColorClasses: a,
    backgroundColorStyles: i
  };
}
function Ra(e, n) {
  const t = j(), a = H(!1);
  if (hn) {
    const i = new IntersectionObserver((l) => {
      a.value = !!l.find((r) => r.isIntersecting);
    }, n);
    be(() => {
      i.disconnect();
    }), R(t, (l, r) => {
      r && (i.unobserve(r), a.value = !1), l && i.observe(l);
    }, {
      flush: "post"
    });
  }
  return {
    intersectionRef: t,
    isIntersecting: a
  };
}
function ut(e, n) {
  let t;
  function a() {
    t = gn(), t.run(() => n.length ? n(() => {
      t == null || t.stop(), a();
    }) : n());
  }
  R(e, (i) => {
    i && !t ? a() : i || (t == null || t.stop(), t = void 0);
  }, {
    immediate: !0
  }), se(() => {
    t == null || t.stop();
  });
}
function ct(e, n, t) {
  let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : (f) => f, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : (f) => f;
  const l = G("useProxiedModel"), r = j(e[n] !== void 0 ? e[n] : t), o = _e(n), u = o !== n ? g(() => {
    var f, v, m, b;
    return e[n], !!(((f = l.vnode.props) != null && f.hasOwnProperty(n) || (v = l.vnode.props) != null && v.hasOwnProperty(o)) && ((m = l.vnode.props) != null && m.hasOwnProperty(`onUpdate:${n}`) || (b = l.vnode.props) != null && b.hasOwnProperty(`onUpdate:${o}`)));
  }) : g(() => {
    var f, v;
    return e[n], !!((f = l.vnode.props) != null && f.hasOwnProperty(n) && ((v = l.vnode.props) != null && v.hasOwnProperty(`onUpdate:${n}`)));
  });
  ut(() => !u.value, () => {
    R(() => e[n], (f) => {
      r.value = f;
    });
  });
  const c = g({
    get() {
      const f = e[n];
      return a(u.value ? f : r.value);
    },
    set(f) {
      const v = i(f), m = La(u.value ? e[n] : r.value);
      m === v || a(m) === f || (r.value = v, l == null || l.emit(`update:${n}`, v));
    }
  });
  return Object.defineProperty(c, "externalValue", {
    get: () => u.value ? e[n] : r.value
  }), c;
}
const _r = Symbol.for("vuetify:locale");
function Ze() {
  const e = oe(_r);
  if (!e) throw new Error("[Vuetify] Could not find injected rtl instance");
  return {
    isRtl: e.isRtl,
    rtlClasses: e.rtlClasses
  };
}
const Qn = {
  center: "center",
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, wn = k({
  location: String
}, "location");
function xn(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, t = arguments.length > 2 ? arguments[2] : void 0;
  const {
    isRtl: a
  } = Ze();
  return {
    locationStyles: g(() => {
      if (!e.location) return {};
      const {
        side: l,
        align: r
      } = an(e.location.split(" ").length > 1 ? e.location : `${e.location} center`, a.value);
      function o(u) {
        return t ? t(u) : 0;
      }
      const s = {};
      return l !== "center" && (n ? s[Qn[l]] = `calc(100% - ${o(l)}px)` : s[l] = 0), r !== "center" ? n ? s[Qn[r]] = `calc(100% - ${o(r)}px)` : s[r] = 0 : (l === "center" ? s.top = s.left = "50%" : s[{
        top: "left",
        bottom: "left",
        left: "top",
        right: "top"
      }[l]] = "50%", s.transform = {
        top: "translateX(-50%)",
        bottom: "translateX(-50%)",
        left: "translateY(-50%)",
        right: "translateY(-50%)",
        center: "translate(-50%, -50%)"
      }[l]), s;
    })
  };
}
const Oe = k({
  rounded: {
    type: [Boolean, Number, String],
    default: void 0
  },
  tile: Boolean
}, "rounded");
function Be(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : xe();
  return {
    roundedClasses: g(() => {
      const a = ze(e) ? e.value : e.rounded, i = ze(e) ? e.value : e.tile, l = [];
      if (a === !0 || a === "")
        l.push(`${n}--rounded`);
      else if (typeof a == "string" || a === 0)
        for (const r of String(a).split(" "))
          l.push(`rounded-${r}`);
      else (i || a === !1) && l.push("rounded-0");
      return l;
    })
  };
}
const te = k({
  tag: {
    type: String,
    default: "div"
  }
}, "tag"), ea = Symbol.for("vuetify:theme"), de = k({
  theme: String
}, "theme");
function fe(e) {
  G("provideTheme");
  const n = oe(ea, null);
  if (!n) throw new Error("Could not find Vuetify theme injection");
  const t = g(() => e.theme ?? n.name.value), a = g(() => n.themes.value[t.value]), i = g(() => n.isDisabled ? void 0 : `v-theme--${t.value}`), l = {
    ...n,
    name: t,
    current: a,
    themeClasses: i
  };
  return he(ea, l), l;
}
const Vr = k({
  absolute: Boolean,
  active: {
    type: Boolean,
    default: !0
  },
  bgColor: String,
  bgOpacity: [Number, String],
  bufferValue: {
    type: [Number, String],
    default: 0
  },
  bufferColor: String,
  bufferOpacity: [Number, String],
  clickable: Boolean,
  color: String,
  height: {
    type: [Number, String],
    default: 4
  },
  indeterminate: Boolean,
  max: {
    type: [Number, String],
    default: 100
  },
  modelValue: {
    type: [Number, String],
    default: 0
  },
  opacity: [Number, String],
  reverse: Boolean,
  stream: Boolean,
  striped: Boolean,
  roundedBar: Boolean,
  ...z(),
  ...wn({
    location: "top"
  }),
  ...Oe(),
  ...te(),
  ...de()
}, "VProgressLinear"), Ha = M()({
  name: "VProgressLinear",
  props: Vr(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, n) {
    var V;
    let {
      slots: t
    } = n;
    const a = ct(e, "modelValue"), {
      isRtl: i,
      rtlClasses: l
    } = Ze(), {
      themeClasses: r
    } = fe(e), {
      locationStyles: o
    } = xn(e), {
      textColorClasses: s,
      textColorStyles: u
    } = it(e, "color"), {
      backgroundColorClasses: c,
      backgroundColorStyles: f
    } = Fe(g(() => e.bgColor || e.color)), {
      backgroundColorClasses: v,
      backgroundColorStyles: m
    } = Fe(g(() => e.bufferColor || e.bgColor || e.color)), {
      backgroundColorClasses: b,
      backgroundColorStyles: y
    } = Fe(e, "color"), {
      roundedClasses: h
    } = Be(e), {
      intersectionRef: L,
      isIntersecting: p
    } = Ra(), x = g(() => parseFloat(e.max)), _ = g(() => parseFloat(e.height)), O = g(() => nt(parseFloat(e.bufferValue) / x.value * 100, 0, 100)), E = g(() => nt(parseFloat(a.value) / x.value * 100, 0, 100)), A = g(() => i.value !== e.reverse), C = g(() => e.indeterminate ? "fade-transition" : "slide-x-transition"), I = Q && ((V = window.matchMedia) == null ? void 0 : V.call(window, "(forced-colors: active)").matches);
    function $(S) {
      if (!L.value) return;
      const {
        left: w,
        right: P,
        width: F
      } = L.value.getBoundingClientRect(), W = A.value ? F - S.clientX + (P - F) : S.clientX - w;
      a.value = Math.round(W / F * x.value);
    }
    return D(() => d(e.tag, {
      ref: L,
      class: ["v-progress-linear", {
        "v-progress-linear--absolute": e.absolute,
        "v-progress-linear--active": e.active && p.value,
        "v-progress-linear--reverse": A.value,
        "v-progress-linear--rounded": e.rounded,
        "v-progress-linear--rounded-bar": e.roundedBar,
        "v-progress-linear--striped": e.striped
      }, h.value, r.value, l.value, e.class],
      style: [{
        bottom: e.location === "bottom" ? 0 : void 0,
        top: e.location === "top" ? 0 : void 0,
        height: e.active ? T(_.value) : 0,
        "--v-progress-linear-height": T(_.value),
        ...e.absolute ? o.value : {}
      }, e.style],
      role: "progressbar",
      "aria-hidden": e.active ? "false" : "true",
      "aria-valuemin": "0",
      "aria-valuemax": e.max,
      "aria-valuenow": e.indeterminate ? void 0 : E.value,
      onClick: e.clickable && $
    }, {
      default: () => [e.stream && d("div", {
        key: "stream",
        class: ["v-progress-linear__stream", s.value],
        style: {
          ...u.value,
          [A.value ? "left" : "right"]: T(-_.value),
          borderTop: `${T(_.value / 2)} dotted`,
          opacity: parseFloat(e.bufferOpacity),
          top: `calc(50% - ${T(_.value / 4)})`,
          width: T(100 - O.value, "%"),
          "--v-progress-linear-stream-to": T(_.value * (A.value ? 1 : -1))
        }
      }, null), d("div", {
        class: ["v-progress-linear__background", I ? void 0 : c.value],
        style: [f.value, {
          opacity: parseFloat(e.bgOpacity),
          width: e.stream ? 0 : void 0
        }]
      }, null), d("div", {
        class: ["v-progress-linear__buffer", I ? void 0 : v.value],
        style: [m.value, {
          opacity: parseFloat(e.bufferOpacity),
          width: T(O.value, "%")
        }]
      }, null), d(Ae, {
        name: C.value
      }, {
        default: () => [e.indeterminate ? d("div", {
          class: "v-progress-linear__indeterminate"
        }, [["long", "short"].map((S) => d("div", {
          key: S,
          class: ["v-progress-linear__indeterminate", S, I ? void 0 : b.value],
          style: y.value
        }, null))]) : d("div", {
          class: ["v-progress-linear__determinate", I ? void 0 : b.value],
          style: [y.value, {
            width: T(E.value, "%")
          }]
        }, null)]
      }), t.default && d("div", {
        class: "v-progress-linear__content"
      }, [t.default({
        value: E.value,
        buffer: O.value
      })])]
    })), {};
  }
}), Er = ["src"], Ar = { class: "title" }, Pr = /* @__PURE__ */ we({
  __name: "AppLoading",
  props: {
    title: {},
    logo: {}
  },
  setup(e) {
    const n = e;
    return (t, a) => (U(), ee(kr, {
      "full-height": "",
      class: "flex-column ga-4 justify-center align-center"
    }, {
      default: B(() => [
        De("h1", null, [
          De("span", null, [
            t.logo ? (U(), et("img", {
              key: 0,
              src: t.logo,
              width: "48"
            }, null, 8, Er)) : Qe("", !0),
            De("span", Ar, Pe(n.title), 1)
          ]),
          d(Ha)
        ])
      ]),
      _: 1
    }));
  }
}), Tr = M()({
  name: "VCardActions",
  props: z(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    return Ot({
      VBtn: {
        slim: !0,
        variant: "text"
      }
    }), D(() => {
      var a;
      return d("div", {
        class: ["v-card-actions", e.class],
        style: e.style
      }, [(a = t.default) == null ? void 0 : a.call(t)]);
    }), {};
  }
}), Ir = k({
  opacity: [Number, String],
  ...z(),
  ...te()
}, "VCardSubtitle"), Da = M()({
  name: "VCardSubtitle",
  props: Ir(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    return D(() => d(e.tag, {
      class: ["v-card-subtitle", e.class],
      style: [{
        "--v-card-subtitle-opacity": e.opacity
      }, e.style]
    }, t)), {};
  }
}), kn = Ba("v-card-title"), Or = k({
  defaults: Object,
  disabled: Boolean,
  reset: [Number, String],
  root: [Boolean, String],
  scoped: Boolean
}, "VDefaultsProvider"), re = M(!1)({
  name: "VDefaultsProvider",
  props: Or(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    const {
      defaults: a,
      disabled: i,
      reset: l,
      root: r,
      scoped: o
    } = Ca(e);
    return Ot(a, {
      reset: l,
      root: r,
      scoped: o,
      disabled: i
    }), () => {
      var s;
      return (s = t.default) == null ? void 0 : s.call(t);
    };
  }
}), ye = [String, Function, Object, Array], Br = Symbol.for("vuetify:icons"), Mt = k({
  icon: {
    type: ye
  },
  // Could not remove this and use makeTagProps, types complained because it is not required
  tag: {
    type: String,
    required: !0
  }
}, "icon"), ta = M()({
  name: "VComponentIcon",
  props: Mt(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    return () => {
      const a = e.icon;
      return d(e.tag, null, {
        default: () => {
          var i;
          return [e.icon ? d(a, null, null) : (i = t.default) == null ? void 0 : i.call(t)];
        }
      });
    };
  }
}), Fa = Bt({
  name: "VSvgIcon",
  inheritAttrs: !1,
  props: Mt(),
  setup(e, n) {
    let {
      attrs: t
    } = n;
    return () => d(e.tag, Z(t, {
      style: null
    }), {
      default: () => [d("svg", {
        class: "v-icon__svg",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        role: "img",
        "aria-hidden": "true"
      }, [Array.isArray(e.icon) ? e.icon.map((a) => Array.isArray(a) ? d("path", {
        d: a[0],
        "fill-opacity": a[1]
      }, null) : d("path", {
        d: a
      }, null)) : d("path", {
        d: e.icon
      }, null)])]
    });
  }
});
Bt({
  name: "VLigatureIcon",
  props: Mt(),
  setup(e) {
    return () => d(e.tag, null, {
      default: () => [e.icon]
    });
  }
});
Bt({
  name: "VClassIcon",
  props: Mt(),
  setup(e) {
    return () => d(e.tag, {
      class: e.icon
    }, null);
  }
});
const Mr = (e) => {
  const n = oe(Br);
  if (!n) throw new Error("Missing Vuetify Icons provide!");
  return {
    iconData: g(() => {
      var s;
      const a = X(e);
      if (!a) return {
        component: ta
      };
      let i = a;
      if (typeof i == "string" && (i = i.trim(), i.startsWith("$") && (i = (s = n.aliases) == null ? void 0 : s[i.slice(1)])), i || Ee(`Could not find aliased icon "${a}"`), Array.isArray(i))
        return {
          component: Fa,
          icon: i
        };
      if (typeof i != "string")
        return {
          component: ta,
          icon: i
        };
      const l = Object.keys(n.sets).find((u) => typeof i == "string" && i.startsWith(`${u}:`)), r = l ? i.slice(l.length + 1) : i;
      return {
        component: n.sets[l ?? n.defaultSet].component,
        icon: r
      };
    })
  };
}, $r = ["x-small", "small", "default", "large", "x-large"], $t = k({
  size: {
    type: [String, Number],
    default: "default"
  }
}, "size");
function Nt(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : xe();
  return Cn(() => {
    let t, a;
    return wt($r, e.size) ? t = `${n}--size-${e.size}` : e.size && (a = {
      width: T(e.size),
      height: T(e.size)
    }), {
      sizeClasses: t,
      sizeStyles: a
    };
  });
}
const Nr = k({
  color: String,
  disabled: Boolean,
  start: Boolean,
  end: Boolean,
  icon: ye,
  ...z(),
  ...$t(),
  ...te({
    tag: "i"
  }),
  ...de()
}, "VIcon"), ce = M()({
  name: "VIcon",
  props: Nr(),
  setup(e, n) {
    let {
      attrs: t,
      slots: a
    } = n;
    const i = j(), {
      themeClasses: l
    } = fe(e), {
      iconData: r
    } = Mr(g(() => i.value || e.icon)), {
      sizeClasses: o
    } = Nt(e), {
      textColorClasses: s,
      textColorStyles: u
    } = it(Y(e, "color"));
    return D(() => {
      var v, m;
      const c = (v = a.default) == null ? void 0 : v.call(a);
      c && (i.value = (m = _a(c).filter((b) => b.type === zi && b.children && typeof b.children == "string")[0]) == null ? void 0 : m.children);
      const f = !!(t.onClick || t.onClickOnce);
      return d(r.value.component, {
        tag: e.tag,
        icon: r.value.icon,
        class: ["v-icon", "notranslate", l.value, o.value, s.value, {
          "v-icon--clickable": f,
          "v-icon--disabled": e.disabled,
          "v-icon--start": e.start,
          "v-icon--end": e.end
        }, e.class],
        style: [o.value ? void 0 : {
          fontSize: T(e.size),
          height: T(e.size),
          width: T(e.size)
        }, u.value, e.style],
        role: f ? "button" : void 0,
        "aria-hidden": !f,
        tabindex: f ? e.disabled ? -1 : 0 : void 0
      }, {
        default: () => [c]
      });
    }), {};
  }
});
function Rr(e) {
  return {
    aspectStyles: g(() => {
      const n = Number(e.aspectRatio);
      return n ? {
        paddingBottom: String(1 / n * 100) + "%"
      } : void 0;
    })
  };
}
const za = k({
  aspectRatio: [String, Number],
  contentClass: null,
  inline: Boolean,
  ...z(),
  ...We()
}, "VResponsive"), na = M()({
  name: "VResponsive",
  props: za(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    const {
      aspectStyles: a
    } = Rr(e), {
      dimensionStyles: i
    } = Ue(e);
    return D(() => {
      var l;
      return d("div", {
        class: ["v-responsive", {
          "v-responsive--inline": e.inline
        }, e.class],
        style: [i.value, e.style]
      }, [d("div", {
        class: "v-responsive__sizer",
        style: a.value
      }, null), (l = t.additional) == null ? void 0 : l.call(t), t.default && d("div", {
        class: ["v-responsive__content", e.contentClass]
      }, [t.default()])]);
    }), {};
  }
}), ja = k({
  transition: {
    type: [Boolean, String, Object],
    default: "fade-transition",
    validator: (e) => e !== !0
  }
}, "transition"), Je = (e, n) => {
  let {
    slots: t
  } = n;
  const {
    transition: a,
    disabled: i,
    group: l,
    ...r
  } = e, {
    component: o = l ? Tt : Ae,
    ...s
  } = typeof a == "object" ? a : {};
  return je(o, Z(typeof a == "string" ? {
    name: i ? "" : a
  } : s, typeof a == "string" ? {} : Object.fromEntries(Object.entries({
    disabled: i,
    group: l
  }).filter((u) => {
    let [c, f] = u;
    return f !== void 0;
  })), r), t);
};
function Hr(e, n) {
  if (!hn) return;
  const t = n.modifiers || {}, a = n.value, {
    handler: i,
    options: l
  } = typeof a == "object" ? a : {
    handler: a,
    options: {}
  }, r = new IntersectionObserver(function() {
    var f;
    let o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], s = arguments.length > 1 ? arguments[1] : void 0;
    const u = (f = e._observe) == null ? void 0 : f[n.instance.$.uid];
    if (!u) return;
    const c = o.some((v) => v.isIntersecting);
    i && (!t.quiet || u.init) && (!t.once || c || u.init) && i(c, o, s), c && t.once ? Wa(e, n) : u.init = !0;
  }, l);
  e._observe = Object(e._observe), e._observe[n.instance.$.uid] = {
    init: !1,
    observer: r
  }, r.observe(e);
}
function Wa(e, n) {
  var a;
  const t = (a = e._observe) == null ? void 0 : a[n.instance.$.uid];
  t && (t.observer.unobserve(e), delete e._observe[n.instance.$.uid]);
}
const Dr = {
  mounted: Hr,
  unmounted: Wa
}, Fr = k({
  absolute: Boolean,
  alt: String,
  cover: Boolean,
  color: String,
  draggable: {
    type: [Boolean, String],
    default: void 0
  },
  eager: Boolean,
  gradient: String,
  lazySrc: String,
  options: {
    type: Object,
    // For more information on types, navigate to:
    // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
    default: () => ({
      root: void 0,
      rootMargin: void 0,
      threshold: void 0
    })
  },
  sizes: String,
  src: {
    type: [String, Object],
    default: ""
  },
  crossorigin: String,
  referrerpolicy: String,
  srcset: String,
  position: String,
  ...za(),
  ...z(),
  ...Oe(),
  ...ja()
}, "VImg"), Ge = M()({
  name: "VImg",
  directives: {
    intersect: Dr
  },
  props: Fr(),
  emits: {
    loadstart: (e) => !0,
    load: (e) => !0,
    error: (e) => !0
  },
  setup(e, n) {
    let {
      emit: t,
      slots: a
    } = n;
    const {
      backgroundColorClasses: i,
      backgroundColorStyles: l
    } = Fe(Y(e, "color")), {
      roundedClasses: r
    } = Be(e), o = G("VImg"), s = H(""), u = j(), c = H(e.eager ? "loading" : "idle"), f = H(), v = H(), m = g(() => e.src && typeof e.src == "object" ? {
      src: e.src.src,
      srcset: e.srcset || e.src.srcset,
      lazySrc: e.lazySrc || e.src.lazySrc,
      aspect: Number(e.aspectRatio || e.src.aspect || 0)
    } : {
      src: e.src,
      srcset: e.srcset,
      lazySrc: e.lazySrc,
      aspect: Number(e.aspectRatio || 0)
    }), b = g(() => m.value.aspect || f.value / v.value || 0);
    R(() => e.src, () => {
      y(c.value !== "idle");
    }), R(b, (S, w) => {
      !S && w && u.value && _(u.value);
    }), ji(() => y());
    function y(S) {
      if (!(e.eager && S) && !(hn && !S && !e.eager)) {
        if (c.value = "loading", m.value.lazySrc) {
          const w = new Image();
          w.src = m.value.lazySrc, _(w, null);
        }
        m.value.src && Ie(() => {
          var w;
          t("loadstart", ((w = u.value) == null ? void 0 : w.currentSrc) || m.value.src), setTimeout(() => {
            var P;
            if (!o.isUnmounted)
              if ((P = u.value) != null && P.complete) {
                if (u.value.naturalWidth || L(), c.value === "error") return;
                b.value || _(u.value, null), c.value === "loading" && h();
              } else
                b.value || _(u.value), p();
          });
        });
      }
    }
    function h() {
      var S;
      o.isUnmounted || (p(), _(u.value), c.value = "loaded", t("load", ((S = u.value) == null ? void 0 : S.currentSrc) || m.value.src));
    }
    function L() {
      var S;
      o.isUnmounted || (c.value = "error", t("error", ((S = u.value) == null ? void 0 : S.currentSrc) || m.value.src));
    }
    function p() {
      const S = u.value;
      S && (s.value = S.currentSrc || S.src);
    }
    let x = -1;
    be(() => {
      clearTimeout(x);
    });
    function _(S) {
      let w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
      const P = () => {
        if (clearTimeout(x), o.isUnmounted) return;
        const {
          naturalHeight: F,
          naturalWidth: W
        } = S;
        F || W ? (f.value = W, v.value = F) : !S.complete && c.value === "loading" && w != null ? x = window.setTimeout(P, w) : (S.currentSrc.endsWith(".svg") || S.currentSrc.startsWith("data:image/svg+xml")) && (f.value = 1, v.value = 1);
      };
      P();
    }
    const O = g(() => ({
      "v-img__img--cover": e.cover,
      "v-img__img--contain": !e.cover
    })), E = () => {
      var P;
      if (!m.value.src || c.value === "idle") return null;
      const S = d("img", {
        class: ["v-img__img", O.value],
        style: {
          objectPosition: e.position
        },
        src: m.value.src,
        srcset: m.value.srcset,
        alt: e.alt,
        crossorigin: e.crossorigin,
        referrerpolicy: e.referrerpolicy,
        draggable: e.draggable,
        sizes: e.sizes,
        ref: u,
        onLoad: h,
        onError: L
      }, null), w = (P = a.sources) == null ? void 0 : P.call(a);
      return d(Je, {
        transition: e.transition,
        appear: !0
      }, {
        default: () => [tt(w ? d("picture", {
          class: "v-img__picture"
        }, [w, S]) : S, [[wa, c.value === "loaded"]])]
      });
    }, A = () => d(Je, {
      transition: e.transition
    }, {
      default: () => [m.value.lazySrc && c.value !== "loaded" && d("img", {
        class: ["v-img__img", "v-img__img--preload", O.value],
        style: {
          objectPosition: e.position
        },
        src: m.value.lazySrc,
        alt: e.alt,
        crossorigin: e.crossorigin,
        referrerpolicy: e.referrerpolicy,
        draggable: e.draggable
      }, null)]
    }), C = () => a.placeholder ? d(Je, {
      transition: e.transition,
      appear: !0
    }, {
      default: () => [(c.value === "loading" || c.value === "error" && !a.error) && d("div", {
        class: "v-img__placeholder"
      }, [a.placeholder()])]
    }) : null, I = () => a.error ? d(Je, {
      transition: e.transition,
      appear: !0
    }, {
      default: () => [c.value === "error" && d("div", {
        class: "v-img__error"
      }, [a.error()])]
    }) : null, $ = () => e.gradient ? d("div", {
      class: "v-img__gradient",
      style: {
        backgroundImage: `linear-gradient(${e.gradient})`
      }
    }, null) : null, V = H(!1);
    {
      const S = R(b, (w) => {
        w && (requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            V.value = !0;
          });
        }), S());
      });
    }
    return D(() => {
      const S = na.filterProps(e);
      return tt(d(na, Z({
        class: ["v-img", {
          "v-img--absolute": e.absolute,
          "v-img--booting": !V.value
        }, i.value, r.value, e.class],
        style: [{
          width: T(e.width === "auto" ? f.value : e.width)
        }, l.value, e.style]
      }, S, {
        aspectRatio: b.value,
        "aria-label": e.alt,
        role: e.alt ? "img" : void 0
      }), {
        additional: () => d(ge, null, [d(E, null, null), d(A, null, null), d($, null, null), d(C, null, null), d(I, null, null)]),
        default: a.default
      }), [[yn("intersect"), {
        handler: y,
        options: e.options
      }, null, {
        once: !0
      }]]);
    }), {
      currentSrc: s,
      image: u,
      state: c,
      naturalWidth: f,
      naturalHeight: v
    };
  }
}), dt = k({
  border: [Boolean, Number, String]
}, "border");
function ft(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : xe();
  return {
    borderClasses: g(() => {
      const a = ze(e) ? e.value : e.border, i = [];
      if (a === !0 || a === "")
        i.push(`${n}--border`);
      else if (typeof a == "string" || a === 0)
        for (const l of String(a).split(" "))
          i.push(`border-${l}`);
      return i;
    })
  };
}
const zr = [null, "default", "comfortable", "compact"], vt = k({
  density: {
    type: String,
    default: "default",
    validator: (e) => zr.includes(e)
  }
}, "density");
function Rt(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : xe();
  return {
    densityClasses: g(() => `${n}--density-${e.density}`)
  };
}
const jr = ["elevated", "flat", "tonal", "outlined", "text", "plain"];
function _n(e, n) {
  return d(ge, null, [e && d("span", {
    key: "overlay",
    class: `${n}__overlay`
  }, null), d("span", {
    key: "underlay",
    class: `${n}__underlay`
  }, null)]);
}
const Ht = k({
  color: String,
  variant: {
    type: String,
    default: "elevated",
    validator: (e) => jr.includes(e)
  }
}, "variant");
function Vn(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : xe();
  const t = g(() => {
    const {
      variant: l
    } = X(e);
    return `${n}--variant-${l}`;
  }), {
    colorClasses: a,
    colorStyles: i
  } = Ln(g(() => {
    const {
      variant: l,
      color: r
    } = X(e);
    return {
      [["elevated", "flat"].includes(l) ? "background" : "text"]: r
    };
  }));
  return {
    colorClasses: a,
    colorStyles: i,
    variantClasses: t
  };
}
const Wr = k({
  start: Boolean,
  end: Boolean,
  icon: ye,
  image: String,
  text: String,
  ...dt(),
  ...z(),
  ...vt(),
  ...Oe(),
  ...$t(),
  ...te(),
  ...de(),
  ...Ht({
    variant: "flat"
  })
}, "VAvatar"), _t = M()({
  name: "VAvatar",
  props: Wr(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    const {
      themeClasses: a
    } = fe(e), {
      borderClasses: i
    } = ft(e), {
      colorClasses: l,
      colorStyles: r,
      variantClasses: o
    } = Vn(e), {
      densityClasses: s
    } = Rt(e), {
      roundedClasses: u
    } = Be(e), {
      sizeClasses: c,
      sizeStyles: f
    } = Nt(e);
    return D(() => d(e.tag, {
      class: ["v-avatar", {
        "v-avatar--start": e.start,
        "v-avatar--end": e.end
      }, a.value, i.value, l.value, s.value, u.value, c.value, o.value, e.class],
      style: [r.value, f.value, e.style]
    }, {
      default: () => [t.default ? d(re, {
        key: "content-defaults",
        defaults: {
          VImg: {
            cover: !0,
            src: e.image
          },
          VIcon: {
            icon: e.icon
          }
        }
      }, {
        default: () => [t.default()]
      }) : e.image ? d(Ge, {
        key: "image",
        src: e.image,
        alt: "",
        cover: !0
      }, null) : e.icon ? d(ce, {
        key: "icon",
        icon: e.icon
      }, null) : e.text, _n(!1, "v-avatar")]
    })), {};
  }
}), Ur = k({
  appendAvatar: String,
  appendIcon: ye,
  prependAvatar: String,
  prependIcon: ye,
  subtitle: [String, Number],
  title: [String, Number],
  ...z(),
  ...vt()
}, "VCardItem"), Zr = M()({
  name: "VCardItem",
  props: Ur(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    return D(() => {
      var u;
      const a = !!(e.prependAvatar || e.prependIcon), i = !!(a || t.prepend), l = !!(e.appendAvatar || e.appendIcon), r = !!(l || t.append), o = !!(e.title != null || t.title), s = !!(e.subtitle != null || t.subtitle);
      return d("div", {
        class: ["v-card-item", e.class],
        style: e.style
      }, [i && d("div", {
        key: "prepend",
        class: "v-card-item__prepend"
      }, [t.prepend ? d(re, {
        key: "prepend-defaults",
        disabled: !a,
        defaults: {
          VAvatar: {
            density: e.density,
            image: e.prependAvatar
          },
          VIcon: {
            density: e.density,
            icon: e.prependIcon
          }
        }
      }, t.prepend) : d(ge, null, [e.prependAvatar && d(_t, {
        key: "prepend-avatar",
        density: e.density,
        image: e.prependAvatar
      }, null), e.prependIcon && d(ce, {
        key: "prepend-icon",
        density: e.density,
        icon: e.prependIcon
      }, null)])]), d("div", {
        class: "v-card-item__content"
      }, [o && d(kn, {
        key: "title"
      }, {
        default: () => {
          var c;
          return [((c = t.title) == null ? void 0 : c.call(t)) ?? e.title];
        }
      }), s && d(Da, {
        key: "subtitle"
      }, {
        default: () => {
          var c;
          return [((c = t.subtitle) == null ? void 0 : c.call(t)) ?? e.subtitle];
        }
      }), (u = t.default) == null ? void 0 : u.call(t)]), r && d("div", {
        key: "append",
        class: "v-card-item__append"
      }, [t.append ? d(re, {
        key: "append-defaults",
        disabled: !l,
        defaults: {
          VAvatar: {
            density: e.density,
            image: e.appendAvatar
          },
          VIcon: {
            density: e.density,
            icon: e.appendIcon
          }
        }
      }, t.append) : d(ge, null, [e.appendIcon && d(ce, {
        key: "append-icon",
        density: e.density,
        icon: e.appendIcon
      }, null), e.appendAvatar && d(_t, {
        key: "append-avatar",
        density: e.density,
        image: e.appendAvatar
      }, null)])])]);
    }), {};
  }
}), Gr = k({
  opacity: [Number, String],
  ...z(),
  ...te()
}, "VCardText"), Ua = M()({
  name: "VCardText",
  props: Gr(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    return D(() => d(e.tag, {
      class: ["v-card-text", e.class],
      style: [{
        "--v-card-text-opacity": e.opacity
      }, e.style]
    }, t)), {};
  }
}), Dt = k({
  elevation: {
    type: [Number, String],
    validator(e) {
      const n = parseInt(e);
      return !isNaN(n) && n >= 0 && // Material Design has a maximum elevation of 24
      // https://material.io/design/environment/elevation.html#default-elevations
      n <= 24;
    }
  }
}, "elevation");
function Ft(e) {
  return {
    elevationClasses: g(() => {
      const t = ze(e) ? e.value : e.elevation, a = [];
      return t == null || a.push(`elevation-${t}`), a;
    })
  };
}
const Za = k({
  loading: [Boolean, String]
}, "loader");
function Ga(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : xe();
  return {
    loaderClasses: g(() => ({
      [`${n}--loading`]: e.loading
    }))
  };
}
function qr(e, n) {
  var a;
  let {
    slots: t
  } = n;
  return d("div", {
    class: `${e.name}__loader`
  }, [((a = t.default) == null ? void 0 : a.call(t, {
    color: e.color,
    isActive: e.active
  })) || d(Ha, {
    absolute: e.absolute,
    active: e.active,
    color: e.color,
    height: "2",
    indeterminate: !0
  }, null)]);
}
const Yr = ["static", "relative", "fixed", "absolute", "sticky"], qa = k({
  position: {
    type: String,
    validator: (
      /* istanbul ignore next */
      (e) => Yr.includes(e)
    )
  }
}, "position");
function Ya(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : xe();
  return {
    positionClasses: g(() => e.position ? `${n}--${e.position}` : void 0)
  };
}
function Kr() {
  const e = G("useRoute");
  return g(() => {
    var n;
    return (n = e == null ? void 0 : e.proxy) == null ? void 0 : n.$route;
  });
}
function Xr() {
  var e, n;
  return (n = (e = G("useRouter")) == null ? void 0 : e.proxy) == null ? void 0 : n.$router;
}
function Ka(e, n) {
  var f, v;
  const t = Wi("RouterLink"), a = g(() => !!(e.href || e.to)), i = g(() => (a == null ? void 0 : a.value) || Nn(n, "click") || Nn(e, "click"));
  if (typeof t == "string" || !("useLink" in t)) {
    const m = Y(e, "href");
    return {
      isLink: a,
      isClickable: i,
      href: m,
      linkProps: le({
        href: m
      })
    };
  }
  const l = g(() => ({
    ...e,
    to: Y(() => e.to || "")
  })), r = t.useLink(l.value), o = g(() => e.to ? r : void 0), s = Kr(), u = g(() => {
    var m, b, y;
    return o.value ? e.exact ? s.value ? ((y = o.value.isExactActive) == null ? void 0 : y.value) && bn(o.value.route.value.query, s.value.query) : ((b = o.value.isExactActive) == null ? void 0 : b.value) ?? !1 : ((m = o.value.isActive) == null ? void 0 : m.value) ?? !1 : !1;
  }), c = g(() => {
    var m;
    return e.to ? (m = o.value) == null ? void 0 : m.route.value.href : e.href;
  });
  return {
    isLink: a,
    isClickable: i,
    isActive: u,
    route: (f = o.value) == null ? void 0 : f.route,
    navigate: (v = o.value) == null ? void 0 : v.navigate,
    href: c,
    linkProps: le({
      href: c,
      "aria-current": g(() => u.value ? "page" : void 0)
    })
  };
}
const Xa = k({
  href: String,
  replace: Boolean,
  to: [String, Object],
  exact: Boolean
}, "router");
let qt = !1;
function Jr(e, n) {
  let t = !1, a, i;
  Q && (Ie(() => {
    window.addEventListener("popstate", l), a = e == null ? void 0 : e.beforeEach((r, o, s) => {
      qt ? t ? n(s) : s() : setTimeout(() => t ? n(s) : s()), qt = !0;
    }), i = e == null ? void 0 : e.afterEach(() => {
      qt = !1;
    });
  }), se(() => {
    window.removeEventListener("popstate", l), a == null || a(), i == null || i();
  }));
  function l(r) {
    var o;
    (o = r.state) != null && o.replaced || (t = !0, setTimeout(() => t = !1));
  }
}
const sn = Symbol("rippleStop"), Qr = 80;
function aa(e, n) {
  e.style.transform = n, e.style.webkitTransform = n;
}
function un(e) {
  return e.constructor.name === "TouchEvent";
}
function Ja(e) {
  return e.constructor.name === "KeyboardEvent";
}
const eo = function(e, n) {
  var f;
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = 0, i = 0;
  if (!Ja(e)) {
    const v = n.getBoundingClientRect(), m = un(e) ? e.touches[e.touches.length - 1] : e;
    a = m.clientX - v.left, i = m.clientY - v.top;
  }
  let l = 0, r = 0.3;
  (f = n._ripple) != null && f.circle ? (r = 0.15, l = n.clientWidth / 2, l = t.center ? l : l + Math.sqrt((a - l) ** 2 + (i - l) ** 2) / 4) : l = Math.sqrt(n.clientWidth ** 2 + n.clientHeight ** 2) / 2;
  const o = `${(n.clientWidth - l * 2) / 2}px`, s = `${(n.clientHeight - l * 2) / 2}px`, u = t.center ? o : `${a - l}px`, c = t.center ? s : `${i - l}px`;
  return {
    radius: l,
    scale: r,
    x: u,
    y: c,
    centerX: o,
    centerY: s
  };
}, Vt = {
  /* eslint-disable max-statements */
  show(e, n) {
    var m;
    let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!((m = n == null ? void 0 : n._ripple) != null && m.enabled))
      return;
    const a = document.createElement("span"), i = document.createElement("span");
    a.appendChild(i), a.className = "v-ripple__container", t.class && (a.className += ` ${t.class}`);
    const {
      radius: l,
      scale: r,
      x: o,
      y: s,
      centerX: u,
      centerY: c
    } = eo(e, n, t), f = `${l * 2}px`;
    i.className = "v-ripple__animation", i.style.width = f, i.style.height = f, n.appendChild(a);
    const v = window.getComputedStyle(n);
    v && v.position === "static" && (n.style.position = "relative", n.dataset.previousPosition = "static"), i.classList.add("v-ripple__animation--enter"), i.classList.add("v-ripple__animation--visible"), aa(i, `translate(${o}, ${s}) scale3d(${r},${r},${r})`), i.dataset.activated = String(performance.now()), setTimeout(() => {
      i.classList.remove("v-ripple__animation--enter"), i.classList.add("v-ripple__animation--in"), aa(i, `translate(${u}, ${c}) scale3d(1,1,1)`);
    }, 0);
  },
  hide(e) {
    var l;
    if (!((l = e == null ? void 0 : e._ripple) != null && l.enabled)) return;
    const n = e.getElementsByClassName("v-ripple__animation");
    if (n.length === 0) return;
    const t = n[n.length - 1];
    if (t.dataset.isHiding) return;
    t.dataset.isHiding = "true";
    const a = performance.now() - Number(t.dataset.activated), i = Math.max(250 - a, 0);
    setTimeout(() => {
      t.classList.remove("v-ripple__animation--in"), t.classList.add("v-ripple__animation--out"), setTimeout(() => {
        var o;
        e.getElementsByClassName("v-ripple__animation").length === 1 && e.dataset.previousPosition && (e.style.position = e.dataset.previousPosition, delete e.dataset.previousPosition), ((o = t.parentNode) == null ? void 0 : o.parentNode) === e && e.removeChild(t.parentNode);
      }, 300);
    }, i);
  }
};
function Qa(e) {
  return typeof e > "u" || !!e;
}
function lt(e) {
  const n = {}, t = e.currentTarget;
  if (!(!(t != null && t._ripple) || t._ripple.touched || e[sn])) {
    if (e[sn] = !0, un(e))
      t._ripple.touched = !0, t._ripple.isTouch = !0;
    else if (t._ripple.isTouch) return;
    if (n.center = t._ripple.centered || Ja(e), t._ripple.class && (n.class = t._ripple.class), un(e)) {
      if (t._ripple.showTimerCommit) return;
      t._ripple.showTimerCommit = () => {
        Vt.show(e, t, n);
      }, t._ripple.showTimer = window.setTimeout(() => {
        var a;
        (a = t == null ? void 0 : t._ripple) != null && a.showTimerCommit && (t._ripple.showTimerCommit(), t._ripple.showTimerCommit = null);
      }, Qr);
    } else
      Vt.show(e, t, n);
  }
}
function ia(e) {
  e[sn] = !0;
}
function ne(e) {
  const n = e.currentTarget;
  if (n != null && n._ripple) {
    if (window.clearTimeout(n._ripple.showTimer), e.type === "touchend" && n._ripple.showTimerCommit) {
      n._ripple.showTimerCommit(), n._ripple.showTimerCommit = null, n._ripple.showTimer = window.setTimeout(() => {
        ne(e);
      });
      return;
    }
    window.setTimeout(() => {
      n._ripple && (n._ripple.touched = !1);
    }), Vt.hide(n);
  }
}
function ei(e) {
  const n = e.currentTarget;
  n != null && n._ripple && (n._ripple.showTimerCommit && (n._ripple.showTimerCommit = null), window.clearTimeout(n._ripple.showTimer));
}
let rt = !1;
function ti(e) {
  !rt && (e.keyCode === Mn.enter || e.keyCode === Mn.space) && (rt = !0, lt(e));
}
function ni(e) {
  rt = !1, ne(e);
}
function ai(e) {
  rt && (rt = !1, ne(e));
}
function ii(e, n, t) {
  const {
    value: a,
    modifiers: i
  } = n, l = Qa(a);
  if (l || Vt.hide(e), e._ripple = e._ripple ?? {}, e._ripple.enabled = l, e._ripple.centered = i.center, e._ripple.circle = i.circle, Hl(a) && a.class && (e._ripple.class = a.class), l && !t) {
    if (i.stop) {
      e.addEventListener("touchstart", ia, {
        passive: !0
      }), e.addEventListener("mousedown", ia);
      return;
    }
    e.addEventListener("touchstart", lt, {
      passive: !0
    }), e.addEventListener("touchend", ne, {
      passive: !0
    }), e.addEventListener("touchmove", ei, {
      passive: !0
    }), e.addEventListener("touchcancel", ne), e.addEventListener("mousedown", lt), e.addEventListener("mouseup", ne), e.addEventListener("mouseleave", ne), e.addEventListener("keydown", ti), e.addEventListener("keyup", ni), e.addEventListener("blur", ai), e.addEventListener("dragstart", ne, {
      passive: !0
    });
  } else !l && t && li(e);
}
function li(e) {
  e.removeEventListener("mousedown", lt), e.removeEventListener("touchstart", lt), e.removeEventListener("touchend", ne), e.removeEventListener("touchmove", ei), e.removeEventListener("touchcancel", ne), e.removeEventListener("mouseup", ne), e.removeEventListener("mouseleave", ne), e.removeEventListener("keydown", ti), e.removeEventListener("keyup", ni), e.removeEventListener("dragstart", ne), e.removeEventListener("blur", ai);
}
function to(e, n) {
  ii(e, n, !1);
}
function no(e) {
  delete e._ripple, li(e);
}
function ao(e, n) {
  if (n.value === n.oldValue)
    return;
  const t = Qa(n.oldValue);
  ii(e, n, t);
}
const ri = {
  mounted: to,
  unmounted: no,
  updated: ao
}, io = k({
  appendAvatar: String,
  appendIcon: ye,
  disabled: Boolean,
  flat: Boolean,
  hover: Boolean,
  image: String,
  link: {
    type: Boolean,
    default: void 0
  },
  prependAvatar: String,
  prependIcon: ye,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  subtitle: [String, Number],
  text: [String, Number],
  title: [String, Number],
  ...dt(),
  ...z(),
  ...vt(),
  ...We(),
  ...Dt(),
  ...Za(),
  ...wn(),
  ...qa(),
  ...Oe(),
  ...Xa(),
  ...te(),
  ...de(),
  ...Ht({
    variant: "elevated"
  })
}, "VCard"), cn = M()({
  name: "VCard",
  directives: {
    Ripple: ri
  },
  props: io(),
  setup(e, n) {
    let {
      attrs: t,
      slots: a
    } = n;
    const {
      themeClasses: i
    } = fe(e), {
      borderClasses: l
    } = ft(e), {
      colorClasses: r,
      colorStyles: o,
      variantClasses: s
    } = Vn(e), {
      densityClasses: u
    } = Rt(e), {
      dimensionStyles: c
    } = Ue(e), {
      elevationClasses: f
    } = Ft(e), {
      loaderClasses: v
    } = Ga(e), {
      locationStyles: m
    } = xn(e), {
      positionClasses: b
    } = Ya(e), {
      roundedClasses: y
    } = Be(e), h = Ka(e, t), L = g(() => e.link !== !1 && h.isLink.value), p = g(() => !e.disabled && e.link !== !1 && (e.link || h.isClickable.value));
    return D(() => {
      const x = L.value ? "a" : e.tag, _ = !!(a.title || e.title != null), O = !!(a.subtitle || e.subtitle != null), E = _ || O, A = !!(a.append || e.appendAvatar || e.appendIcon), C = !!(a.prepend || e.prependAvatar || e.prependIcon), I = !!(a.image || e.image), $ = E || C || A, V = !!(a.text || e.text != null);
      return tt(d(x, Z({
        class: ["v-card", {
          "v-card--disabled": e.disabled,
          "v-card--flat": e.flat,
          "v-card--hover": e.hover && !(e.disabled || e.flat),
          "v-card--link": p.value
        }, i.value, l.value, r.value, u.value, f.value, v.value, b.value, y.value, s.value, e.class],
        style: [o.value, c.value, m.value, e.style],
        onClick: p.value && h.navigate,
        tabindex: e.disabled ? -1 : void 0
      }, h.linkProps), {
        default: () => {
          var S;
          return [I && d("div", {
            key: "image",
            class: "v-card__image"
          }, [a.image ? d(re, {
            key: "image-defaults",
            disabled: !e.image,
            defaults: {
              VImg: {
                cover: !0,
                src: e.image
              }
            }
          }, a.image) : d(Ge, {
            key: "image-img",
            cover: !0,
            src: e.image
          }, null)]), d(qr, {
            name: "v-card",
            active: !!e.loading,
            color: typeof e.loading == "boolean" ? void 0 : e.loading
          }, {
            default: a.loader
          }), $ && d(Zr, {
            key: "item",
            prependAvatar: e.prependAvatar,
            prependIcon: e.prependIcon,
            title: e.title,
            subtitle: e.subtitle,
            appendAvatar: e.appendAvatar,
            appendIcon: e.appendIcon
          }, {
            default: a.item,
            prepend: a.prepend,
            title: a.title,
            subtitle: a.subtitle,
            append: a.append
          }), V && d(Ua, {
            key: "text"
          }, {
            default: () => {
              var w;
              return [((w = a.text) == null ? void 0 : w.call(a)) ?? e.text];
            }
          }), (S = a.default) == null ? void 0 : S.call(a), a.actions && d(Tr, null, {
            default: a.actions
          }), _n(p.value, "v-card")];
        }
      }), [[yn("ripple"), p.value && e.ripple]]);
    }), {};
  }
}), lo = k({
  fluid: {
    type: Boolean,
    default: !1
  },
  ...z(),
  ...We(),
  ...te()
}, "VContainer"), ro = M()({
  name: "VContainer",
  props: lo(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    const {
      rtlClasses: a
    } = Ze(), {
      dimensionStyles: i
    } = Ue(e);
    return D(() => d(e.tag, {
      class: ["v-container", {
        "v-container--fluid": e.fluid
      }, a.value, e.class],
      style: [i.value, e.style]
    }, t)), {};
  }
}), zt = ["sm", "md", "lg", "xl", "xxl"], oo = Symbol.for("vuetify:display");
function so() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : xe();
  const t = oe(oo);
  if (!t) throw new Error("Could not find Vuetify display injection");
  const a = g(() => {
    if (e.mobile != null) return e.mobile;
    if (!e.mobileBreakpoint) return t.mobile.value;
    const l = typeof e.mobileBreakpoint == "number" ? e.mobileBreakpoint : t.thresholds.value[e.mobileBreakpoint];
    return t.width.value < l;
  }), i = g(() => n ? {
    [`${n}--mobile`]: a.value
  } : {});
  return {
    ...t,
    displayClasses: i,
    mobile: a
  };
}
const oi = zt.reduce((e, n) => (e[n] = {
  type: [Boolean, String, Number],
  default: !1
}, e), {}), si = zt.reduce((e, n) => {
  const t = "offset" + ot(n);
  return e[t] = {
    type: [String, Number],
    default: null
  }, e;
}, {}), ui = zt.reduce((e, n) => {
  const t = "order" + ot(n);
  return e[t] = {
    type: [String, Number],
    default: null
  }, e;
}, {}), la = {
  col: Object.keys(oi),
  offset: Object.keys(si),
  order: Object.keys(ui)
};
function uo(e, n, t) {
  let a = e;
  if (!(t == null || t === !1)) {
    if (n) {
      const i = n.replace(e, "");
      a += `-${i}`;
    }
    return e === "col" && (a = "v-" + a), e === "col" && (t === "" || t === !0) || (a += `-${t}`), a.toLowerCase();
  }
}
const co = ["auto", "start", "end", "center", "baseline", "stretch"], fo = k({
  cols: {
    type: [Boolean, String, Number],
    default: !1
  },
  ...oi,
  offset: {
    type: [String, Number],
    default: null
  },
  ...si,
  order: {
    type: [String, Number],
    default: null
  },
  ...ui,
  alignSelf: {
    type: String,
    default: null,
    validator: (e) => co.includes(e)
  },
  ...z(),
  ...te()
}, "VCol"), vo = M()({
  name: "VCol",
  props: fo(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    const a = g(() => {
      const i = [];
      let l;
      for (l in la)
        la[l].forEach((o) => {
          const s = e[o], u = uo(l, o, s);
          u && i.push(u);
        });
      const r = i.some((o) => o.startsWith("v-col-"));
      return i.push({
        // Default to .v-col if no other col-{bp}-* classes generated nor `cols` specified.
        "v-col": !r || !e.cols,
        [`v-col-${e.cols}`]: e.cols,
        [`offset-${e.offset}`]: e.offset,
        [`order-${e.order}`]: e.order,
        [`align-self-${e.alignSelf}`]: e.alignSelf
      }), i;
    });
    return () => {
      var i;
      return je(e.tag, {
        class: [a.value, e.class],
        style: e.style
      }, (i = t.default) == null ? void 0 : i.call(t));
    };
  }
}), En = ["start", "end", "center"], ci = ["space-between", "space-around", "space-evenly"];
function An(e, n) {
  return zt.reduce((t, a) => {
    const i = e + ot(a);
    return t[i] = n(), t;
  }, {});
}
const mo = [...En, "baseline", "stretch"], di = (e) => mo.includes(e), fi = An("align", () => ({
  type: String,
  default: null,
  validator: di
})), go = [...En, ...ci], vi = (e) => go.includes(e), mi = An("justify", () => ({
  type: String,
  default: null,
  validator: vi
})), yo = [...En, ...ci, "stretch"], gi = (e) => yo.includes(e), yi = An("alignContent", () => ({
  type: String,
  default: null,
  validator: gi
})), ra = {
  align: Object.keys(fi),
  justify: Object.keys(mi),
  alignContent: Object.keys(yi)
}, ho = {
  align: "align",
  justify: "justify",
  alignContent: "align-content"
};
function bo(e, n, t) {
  let a = ho[e];
  if (t != null) {
    if (n) {
      const i = n.replace(e, "");
      a += `-${i}`;
    }
    return a += `-${t}`, a.toLowerCase();
  }
}
const Co = k({
  dense: Boolean,
  noGutters: Boolean,
  align: {
    type: String,
    default: null,
    validator: di
  },
  ...fi,
  justify: {
    type: String,
    default: null,
    validator: vi
  },
  ...mi,
  alignContent: {
    type: String,
    default: null,
    validator: gi
  },
  ...yi,
  ...z(),
  ...te()
}, "VRow"), po = M()({
  name: "VRow",
  props: Co(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    const a = g(() => {
      const i = [];
      let l;
      for (l in ra)
        ra[l].forEach((r) => {
          const o = e[r], s = bo(l, r, o);
          s && i.push(s);
        });
      return i.push({
        "v-row--no-gutters": e.noGutters,
        "v-row--dense": e.dense,
        [`align-${e.align}`]: e.align,
        [`justify-${e.justify}`]: e.justify,
        [`align-content-${e.alignContent}`]: e.alignContent
      }), i;
    });
    return () => {
      var i;
      return je(e.tag, {
        class: ["v-row", a.value, e.class],
        style: e.style
      }, (i = t.default) == null ? void 0 : i.call(t));
    };
  }
}), So = Ba("v-spacer", "div", "VSpacer"), Lo = /* @__PURE__ */ we({
  __name: "AppSwitcherDropdown",
  props: {
    apps: { default: () => [] }
  },
  setup(e) {
    const n = e;
    return (t, a) => (U(), ee(cn, {
      elevation: 16,
      style: { width: "500px" }
    }, {
      default: B(() => [
        d(ro, { fluid: "" }, {
          default: B(() => [
            d(po, { dense: "" }, {
              default: B(() => [
                (U(!0), et(ge, null, xa(n.apps, (i, l) => (U(), ee(vo, {
                  cols: "4",
                  key: i.id,
                  title: i.description,
                  class: "application",
                  style: Ui({ "--index": l })
                }, {
                  default: B(() => [
                    d(cn, {
                      flat: "",
                      href: i.applicationUrl,
                      class: "application__button"
                    }, {
                      default: B(() => [
                        d(Ge, {
                          src: i.logoUrl,
                          width: 64,
                          height: 64,
                          class: "mt-3",
                          alt: i.friendlyName
                        }, null, 8, ["src", "alt"]),
                        d(kn, { class: "text-subtitle-1" }, {
                          default: B(() => [
                            Ne(Pe(i.friendlyName), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["href"])
                  ]),
                  _: 2
                }, 1032, ["title", "style"]))), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), hi = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [a, i] of n)
    t[a] = i;
  return t;
}, wo = /* @__PURE__ */ hi(Lo, [["__scopeId", "data-v-7c31969f"]]), bi = k({
  baseColor: String,
  divided: Boolean,
  ...dt(),
  ...z(),
  ...vt(),
  ...Dt(),
  ...Oe(),
  ...te(),
  ...de(),
  ...Ht()
}, "VBtnGroup"), oa = M()({
  name: "VBtnGroup",
  props: bi(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    const {
      themeClasses: a
    } = fe(e), {
      densityClasses: i
    } = Rt(e), {
      borderClasses: l
    } = ft(e), {
      elevationClasses: r
    } = Ft(e), {
      roundedClasses: o
    } = Be(e);
    Ot({
      VBtn: {
        height: "auto",
        baseColor: Y(e, "baseColor"),
        color: Y(e, "color"),
        density: Y(e, "density"),
        flat: !0,
        variant: Y(e, "variant")
      }
    }), D(() => d(e.tag, {
      class: ["v-btn-group", {
        "v-btn-group--divided": e.divided
      }, a.value, l.value, i.value, r.value, o.value, e.class],
      style: e.style
    }, t));
  }
}), xo = k({
  modelValue: {
    type: null,
    default: void 0
  },
  multiple: Boolean,
  mandatory: [Boolean, String],
  max: Number,
  selectedClass: String,
  disabled: Boolean
}, "group"), ko = k({
  value: null,
  disabled: Boolean,
  selectedClass: String
}, "group-item");
function _o(e, n) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  const a = G("useGroupItem");
  if (!a)
    throw new Error("[Vuetify] useGroupItem composable must be used inside a component setup function");
  const i = It();
  he(Symbol.for(`${n.description}:id`), i);
  const l = oe(n, null);
  if (!l) {
    if (!t) return l;
    throw new Error(`[Vuetify] Could not find useGroup injection with symbol ${n.description}`);
  }
  const r = Y(e, "value"), o = g(() => !!(l.disabled.value || e.disabled));
  l.register({
    id: i,
    value: r,
    disabled: o
  }, a), be(() => {
    l.unregister(i);
  });
  const s = g(() => l.isSelected(i)), u = g(() => l.items.value[0].id === i), c = g(() => l.items.value[l.items.value.length - 1].id === i), f = g(() => s.value && [l.selectedClass.value, e.selectedClass]);
  return R(s, (v) => {
    a.emit("group:selected", {
      value: v
    });
  }, {
    flush: "sync"
  }), {
    id: i,
    isSelected: s,
    isFirst: u,
    isLast: c,
    toggle: () => l.select(i, !s.value),
    select: (v) => l.select(i, v),
    selectedClass: f,
    value: r,
    disabled: o,
    group: l
  };
}
function Vo(e, n) {
  let t = !1;
  const a = le([]), i = ct(e, "modelValue", [], (v) => v == null ? [] : Ci(a, Wl(v)), (v) => {
    const m = Ao(a, v);
    return e.multiple ? m : m[0];
  }), l = G("useGroup");
  function r(v, m) {
    const b = v, y = Symbol.for(`${n.description}:id`), L = He(y, l == null ? void 0 : l.vnode).indexOf(m);
    X(b.value) == null && (b.value = L, b.useIndexAsValue = !0), L > -1 ? a.splice(L, 0, b) : a.push(b);
  }
  function o(v) {
    if (t) return;
    s();
    const m = a.findIndex((b) => b.id === v);
    a.splice(m, 1);
  }
  function s() {
    const v = a.find((m) => !m.disabled);
    v && e.mandatory === "force" && !i.value.length && (i.value = [v.id]);
  }
  st(() => {
    s();
  }), be(() => {
    t = !0;
  }), Zi(() => {
    for (let v = 0; v < a.length; v++)
      a[v].useIndexAsValue && (a[v].value = v);
  });
  function u(v, m) {
    const b = a.find((y) => y.id === v);
    if (!(m && (b != null && b.disabled)))
      if (e.multiple) {
        const y = i.value.slice(), h = y.findIndex((p) => p === v), L = ~h;
        if (m = m ?? !L, L && e.mandatory && y.length <= 1 || !L && e.max != null && y.length + 1 > e.max) return;
        h < 0 && m ? y.push(v) : h >= 0 && !m && y.splice(h, 1), i.value = y;
      } else {
        const y = i.value.includes(v);
        if (e.mandatory && y) return;
        i.value = m ?? !y ? [v] : [];
      }
  }
  function c(v) {
    if (e.multiple && Ee('This method is not supported when using "multiple" prop'), i.value.length) {
      const m = i.value[0], b = a.findIndex((L) => L.id === m);
      let y = (b + v) % a.length, h = a[y];
      for (; h.disabled && y !== b; )
        y = (y + v) % a.length, h = a[y];
      if (h.disabled) return;
      i.value = [a[y].id];
    } else {
      const m = a.find((b) => !b.disabled);
      m && (i.value = [m.id]);
    }
  }
  const f = {
    register: r,
    unregister: o,
    selected: i,
    select: u,
    disabled: Y(e, "disabled"),
    prev: () => c(a.length - 1),
    next: () => c(1),
    isSelected: (v) => i.value.includes(v),
    selectedClass: g(() => e.selectedClass),
    items: g(() => a),
    getItemIndex: (v) => Eo(a, v)
  };
  return he(n, f), f;
}
function Eo(e, n) {
  const t = Ci(e, [n]);
  return t.length ? e.findIndex((a) => a.id === t[0]) : -1;
}
function Ci(e, n) {
  const t = [];
  return n.forEach((a) => {
    const i = e.find((r) => bn(a, r.value)), l = e[a];
    (i == null ? void 0 : i.value) != null ? t.push(i.id) : l != null && t.push(l.id);
  }), t;
}
function Ao(e, n) {
  const t = [];
  return n.forEach((a) => {
    const i = e.findIndex((l) => l.id === a);
    if (~i) {
      const l = e[i];
      t.push(l.value != null ? l.value : i);
    }
  }), t;
}
const pi = Symbol.for("vuetify:v-btn-toggle"), Po = k({
  ...bi(),
  ...xo()
}, "VBtnToggle");
M()({
  name: "VBtnToggle",
  props: Po(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, n) {
    let {
      slots: t
    } = n;
    const {
      isSelected: a,
      next: i,
      prev: l,
      select: r,
      selected: o
    } = Vo(e, pi);
    return D(() => {
      const s = oa.filterProps(e);
      return d(oa, Z({
        class: ["v-btn-toggle", e.class]
      }, s, {
        style: e.style
      }), {
        default: () => {
          var u;
          return [(u = t.default) == null ? void 0 : u.call(t, {
            isSelected: a,
            next: i,
            prev: l,
            select: r,
            selected: o
          })];
        }
      });
    }), {
      next: i,
      prev: l,
      select: r
    };
  }
});
const To = k({
  bgColor: String,
  color: String,
  indeterminate: [Boolean, String],
  modelValue: {
    type: [Number, String],
    default: 0
  },
  rotate: {
    type: [Number, String],
    default: 0
  },
  width: {
    type: [Number, String],
    default: 4
  },
  ...z(),
  ...$t(),
  ...te({
    tag: "div"
  }),
  ...de()
}, "VProgressCircular"), Io = M()({
  name: "VProgressCircular",
  props: To(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    const a = 20, i = 2 * Math.PI * a, l = j(), {
      themeClasses: r
    } = fe(e), {
      sizeClasses: o,
      sizeStyles: s
    } = Nt(e), {
      textColorClasses: u,
      textColorStyles: c
    } = it(Y(e, "color")), {
      textColorClasses: f,
      textColorStyles: v
    } = it(Y(e, "bgColor")), {
      intersectionRef: m,
      isIntersecting: b
    } = Ra(), {
      resizeRef: y,
      contentRect: h
    } = $a(), L = g(() => Math.max(0, Math.min(100, parseFloat(e.modelValue)))), p = g(() => Number(e.width)), x = g(() => s.value ? Number(e.size) : h.value ? h.value.width : Math.max(p.value, 32)), _ = g(() => a / (1 - p.value / x.value) * 2), O = g(() => p.value / x.value * _.value), E = g(() => T((100 - L.value) / 100 * i));
    return Te(() => {
      m.value = l.value, y.value = l.value;
    }), D(() => d(e.tag, {
      ref: l,
      class: ["v-progress-circular", {
        "v-progress-circular--indeterminate": !!e.indeterminate,
        "v-progress-circular--visible": b.value,
        "v-progress-circular--disable-shrink": e.indeterminate === "disable-shrink"
      }, r.value, o.value, u.value, e.class],
      style: [s.value, c.value, e.style],
      role: "progressbar",
      "aria-valuemin": "0",
      "aria-valuemax": "100",
      "aria-valuenow": e.indeterminate ? void 0 : L.value
    }, {
      default: () => [d("svg", {
        style: {
          transform: `rotate(calc(-90deg + ${Number(e.rotate)}deg))`
        },
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: `0 0 ${_.value} ${_.value}`
      }, [d("circle", {
        class: ["v-progress-circular__underlay", f.value],
        style: v.value,
        fill: "transparent",
        cx: "50%",
        cy: "50%",
        r: a,
        "stroke-width": O.value,
        "stroke-dasharray": i,
        "stroke-dashoffset": 0
      }, null), d("circle", {
        class: "v-progress-circular__overlay",
        fill: "transparent",
        cx: "50%",
        cy: "50%",
        r: a,
        "stroke-width": O.value,
        "stroke-dasharray": i,
        "stroke-dashoffset": E.value
      }, null)]), t.default && d("div", {
        class: "v-progress-circular__content"
      }, [t.default({
        value: L.value
      })])]
    })), {};
  }
});
function Oo(e, n) {
  R(() => {
    var t;
    return (t = e.isActive) == null ? void 0 : t.value;
  }, (t) => {
    e.isLink.value && t && n && Ie(() => {
      n(!0);
    });
  }, {
    immediate: !0
  });
}
const Si = k({
  active: {
    type: Boolean,
    default: void 0
  },
  activeColor: String,
  baseColor: String,
  symbol: {
    type: null,
    default: pi
  },
  flat: Boolean,
  icon: [Boolean, String, Function, Object],
  prependIcon: ye,
  appendIcon: ye,
  block: Boolean,
  readonly: Boolean,
  slim: Boolean,
  stacked: Boolean,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  text: String,
  ...dt(),
  ...z(),
  ...vt(),
  ...We(),
  ...Dt(),
  ...ko(),
  ...Za(),
  ...wn(),
  ...qa(),
  ...Oe(),
  ...Xa(),
  ...$t(),
  ...te({
    tag: "button"
  }),
  ...de(),
  ...Ht({
    variant: "elevated"
  })
}, "VBtn"), mt = M()({
  name: "VBtn",
  props: Si(),
  emits: {
    "group:selected": (e) => !0
  },
  setup(e, n) {
    let {
      attrs: t,
      slots: a
    } = n;
    const {
      themeClasses: i
    } = fe(e), {
      borderClasses: l
    } = ft(e), {
      densityClasses: r
    } = Rt(e), {
      dimensionStyles: o
    } = Ue(e), {
      elevationClasses: s
    } = Ft(e), {
      loaderClasses: u
    } = Ga(e), {
      locationStyles: c
    } = xn(e), {
      positionClasses: f
    } = Ya(e), {
      roundedClasses: v
    } = Be(e), {
      sizeClasses: m,
      sizeStyles: b
    } = Nt(e), y = _o(e, e.symbol, !1), h = Ka(e, t), L = g(() => {
      var V;
      return e.active !== void 0 ? e.active : h.isLink.value ? (V = h.isActive) == null ? void 0 : V.value : y == null ? void 0 : y.isSelected.value;
    }), p = g(() => L.value ? e.activeColor ?? e.color : e.color), x = g(() => {
      var S, w;
      return {
        color: (y == null ? void 0 : y.isSelected.value) && (!h.isLink.value || ((S = h.isActive) == null ? void 0 : S.value)) || !y || ((w = h.isActive) == null ? void 0 : w.value) ? p.value ?? e.baseColor : e.baseColor,
        variant: e.variant
      };
    }), {
      colorClasses: _,
      colorStyles: O,
      variantClasses: E
    } = Vn(x), A = g(() => (y == null ? void 0 : y.disabled.value) || e.disabled), C = g(() => e.variant === "elevated" && !(e.disabled || e.flat || e.border)), I = g(() => {
      if (!(e.value === void 0 || typeof e.value == "symbol"))
        return Object(e.value) === e.value ? JSON.stringify(e.value, null, 0) : e.value;
    });
    function $(V) {
      var S;
      A.value || h.isLink.value && (V.metaKey || V.ctrlKey || V.shiftKey || V.button !== 0 || t.target === "_blank") || ((S = h.navigate) == null || S.call(h, V), y == null || y.toggle());
    }
    return Oo(h, y == null ? void 0 : y.select), D(() => {
      const V = h.isLink.value ? "a" : e.tag, S = !!(e.prependIcon || a.prepend), w = !!(e.appendIcon || a.append), P = !!(e.icon && e.icon !== !0);
      return tt(d(V, Z({
        type: V === "a" ? void 0 : "button",
        class: ["v-btn", y == null ? void 0 : y.selectedClass.value, {
          "v-btn--active": L.value,
          "v-btn--block": e.block,
          "v-btn--disabled": A.value,
          "v-btn--elevated": C.value,
          "v-btn--flat": e.flat,
          "v-btn--icon": !!e.icon,
          "v-btn--loading": e.loading,
          "v-btn--readonly": e.readonly,
          "v-btn--slim": e.slim,
          "v-btn--stacked": e.stacked
        }, i.value, l.value, _.value, r.value, s.value, u.value, f.value, v.value, m.value, E.value, e.class],
        style: [O.value, o.value, c.value, b.value, e.style],
        "aria-busy": e.loading ? !0 : void 0,
        disabled: A.value || void 0,
        tabindex: e.loading || e.readonly ? -1 : void 0,
        onClick: $,
        value: I.value
      }, h.linkProps), {
        default: () => {
          var F;
          return [_n(!0, "v-btn"), !e.icon && S && d("span", {
            key: "prepend",
            class: "v-btn__prepend"
          }, [a.prepend ? d(re, {
            key: "prepend-defaults",
            disabled: !e.prependIcon,
            defaults: {
              VIcon: {
                icon: e.prependIcon
              }
            }
          }, a.prepend) : d(ce, {
            key: "prepend-icon",
            icon: e.prependIcon
          }, null)]), d("span", {
            class: "v-btn__content",
            "data-no-activator": ""
          }, [!a.default && P ? d(ce, {
            key: "content-icon",
            icon: e.icon
          }, null) : d(re, {
            key: "content-defaults",
            disabled: !P,
            defaults: {
              VIcon: {
                icon: e.icon
              }
            }
          }, {
            default: () => {
              var W;
              return [((W = a.default) == null ? void 0 : W.call(a)) ?? e.text];
            }
          })]), !e.icon && w && d("span", {
            key: "append",
            class: "v-btn__append"
          }, [a.append ? d(re, {
            key: "append-defaults",
            disabled: !e.appendIcon,
            defaults: {
              VIcon: {
                icon: e.appendIcon
              }
            }
          }, a.append) : d(ce, {
            key: "append-icon",
            icon: e.appendIcon
          }, null)]), !!e.loading && d("span", {
            key: "loader",
            class: "v-btn__loader"
          }, [((F = a.loader) == null ? void 0 : F.call(a)) ?? d(Io, {
            color: typeof e.loading == "boolean" ? void 0 : e.loading,
            indeterminate: !0,
            width: "2"
          }, null)])];
        }
      }), [[ri, !A.value && e.ripple, "", {
        center: !!e.icon
      }]]);
    }), {
      group: y
    };
  }
}), Bo = k({
  disabled: Boolean,
  group: Boolean,
  hideOnLeave: Boolean,
  leaveAbsolute: Boolean,
  mode: String,
  origin: String
}, "transition");
function ae(e, n, t) {
  return M()({
    name: e,
    props: Bo({
      mode: t,
      origin: n
    }),
    setup(a, i) {
      let {
        slots: l
      } = i;
      const r = {
        onBeforeEnter(o) {
          a.origin && (o.style.transformOrigin = a.origin);
        },
        onLeave(o) {
          if (a.leaveAbsolute) {
            const {
              offsetTop: s,
              offsetLeft: u,
              offsetWidth: c,
              offsetHeight: f
            } = o;
            o._transitionInitialStyles = {
              position: o.style.position,
              top: o.style.top,
              left: o.style.left,
              width: o.style.width,
              height: o.style.height
            }, o.style.position = "absolute", o.style.top = `${s}px`, o.style.left = `${u}px`, o.style.width = `${c}px`, o.style.height = `${f}px`;
          }
          a.hideOnLeave && o.style.setProperty("display", "none", "important");
        },
        onAfterLeave(o) {
          if (a.leaveAbsolute && (o != null && o._transitionInitialStyles)) {
            const {
              position: s,
              top: u,
              left: c,
              width: f,
              height: v
            } = o._transitionInitialStyles;
            delete o._transitionInitialStyles, o.style.position = s || "", o.style.top = u || "", o.style.left = c || "", o.style.width = f || "", o.style.height = v || "";
          }
        }
      };
      return () => {
        const o = a.group ? Tt : Ae;
        return je(o, {
          name: a.disabled ? "" : e,
          css: !a.disabled,
          ...a.group ? void 0 : {
            mode: a.mode
          },
          ...a.disabled ? {} : r
        }, l.default);
      };
    }
  });
}
function Li(e, n) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "in-out";
  return M()({
    name: e,
    props: {
      mode: {
        type: String,
        default: t
      },
      disabled: Boolean,
      group: Boolean
    },
    setup(a, i) {
      let {
        slots: l
      } = i;
      const r = a.group ? Tt : Ae;
      return () => je(r, {
        name: a.disabled ? "" : e,
        css: !a.disabled,
        // mode: props.mode, // TODO: vuejs/vue-next#3104
        ...a.disabled ? {} : n
      }, l.default);
    }
  });
}
function wi() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  const t = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1) ? "width" : "height", a = pa(`offset-${t}`);
  return {
    onBeforeEnter(r) {
      r._parent = r.parentNode, r._initialStyle = {
        transition: r.style.transition,
        overflow: r.style.overflow,
        [t]: r.style[t]
      };
    },
    onEnter(r) {
      const o = r._initialStyle;
      r.style.setProperty("transition", "none", "important"), r.style.overflow = "hidden";
      const s = `${r[a]}px`;
      r.style[t] = "0", r.offsetHeight, r.style.transition = o.transition, e && r._parent && r._parent.classList.add(e), requestAnimationFrame(() => {
        r.style[t] = s;
      });
    },
    onAfterEnter: l,
    onEnterCancelled: l,
    onLeave(r) {
      r._initialStyle = {
        transition: "",
        overflow: r.style.overflow,
        [t]: r.style[t]
      }, r.style.overflow = "hidden", r.style[t] = `${r[a]}px`, r.offsetHeight, requestAnimationFrame(() => r.style[t] = "0");
    },
    onAfterLeave: i,
    onLeaveCancelled: i
  };
  function i(r) {
    e && r._parent && r._parent.classList.remove(e), l(r);
  }
  function l(r) {
    const o = r._initialStyle[t];
    r.style.overflow = r._initialStyle.overflow, o != null && (r.style[t] = o), delete r._initialStyle;
  }
}
const Mo = k({
  target: [Object, Array]
}, "v-dialog-transition"), $o = M()({
  name: "VDialogTransition",
  props: Mo(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    const a = {
      onBeforeEnter(i) {
        i.style.pointerEvents = "none", i.style.visibility = "hidden";
      },
      async onEnter(i, l) {
        var v;
        await new Promise((m) => requestAnimationFrame(m)), await new Promise((m) => requestAnimationFrame(m)), i.style.visibility = "";
        const {
          x: r,
          y: o,
          sx: s,
          sy: u,
          speed: c
        } = ua(e.target, i), f = Ke(i, [{
          transform: `translate(${r}px, ${o}px) scale(${s}, ${u})`,
          opacity: 0
        }, {}], {
          duration: 225 * c,
          easing: mr
        });
        (v = sa(i)) == null || v.forEach((m) => {
          Ke(m, [{
            opacity: 0
          }, {
            opacity: 0,
            offset: 0.33
          }, {}], {
            duration: 225 * 2 * c,
            easing: rn
          });
        }), f.finished.then(() => l());
      },
      onAfterEnter(i) {
        i.style.removeProperty("pointer-events");
      },
      onBeforeLeave(i) {
        i.style.pointerEvents = "none";
      },
      async onLeave(i, l) {
        var v;
        await new Promise((m) => requestAnimationFrame(m));
        const {
          x: r,
          y: o,
          sx: s,
          sy: u,
          speed: c
        } = ua(e.target, i);
        Ke(i, [{}, {
          transform: `translate(${r}px, ${o}px) scale(${s}, ${u})`,
          opacity: 0
        }], {
          duration: 125 * c,
          easing: gr
        }).finished.then(() => l()), (v = sa(i)) == null || v.forEach((m) => {
          Ke(m, [{}, {
            opacity: 0,
            offset: 0.2
          }, {
            opacity: 0
          }], {
            duration: 125 * 2 * c,
            easing: rn
          });
        });
      },
      onAfterLeave(i) {
        i.style.removeProperty("pointer-events");
      }
    };
    return () => e.target ? d(Ae, Z({
      name: "dialog-transition"
    }, a, {
      css: !1
    }), t) : d(Ae, {
      name: "dialog-transition"
    }, t);
  }
});
function sa(e) {
  var t;
  const n = (t = e.querySelector(":scope > .v-card, :scope > .v-sheet, :scope > .v-list")) == null ? void 0 : t.children;
  return n && [...n];
}
function ua(e, n) {
  const t = Pa(e), a = Ta(n), [i, l] = getComputedStyle(n).transformOrigin.split(" ").map((L) => parseFloat(L)), [r, o] = getComputedStyle(n).getPropertyValue("--v-overlay-anchor-origin").split(" ");
  let s = t.left + t.width / 2;
  r === "left" || o === "left" ? s -= t.width / 2 : (r === "right" || o === "right") && (s += t.width / 2);
  let u = t.top + t.height / 2;
  r === "top" || o === "top" ? u -= t.height / 2 : (r === "bottom" || o === "bottom") && (u += t.height / 2);
  const c = t.width / a.width, f = t.height / a.height, v = Math.max(1, c, f), m = c / v || 0, b = f / v || 0, y = a.width * a.height / (window.innerWidth * window.innerHeight), h = y > 0.12 ? Math.min(1.5, (y - 0.12) * 10 + 1) : 1;
  return {
    x: s - (i + a.left),
    y: u - (l + a.top),
    sx: m,
    sy: b,
    speed: h
  };
}
ae("fab-transition", "center center", "out-in");
ae("dialog-bottom-transition");
ae("dialog-top-transition");
ae("fade-transition");
ae("scale-transition");
ae("scroll-x-transition");
ae("scroll-x-reverse-transition");
ae("scroll-y-transition");
ae("scroll-y-reverse-transition");
ae("slide-x-transition");
ae("slide-x-reverse-transition");
ae("slide-y-transition");
ae("slide-y-reverse-transition");
const No = Li("expand-transition", wi());
Li("expand-x-transition", wi("", !0));
function Yt(e, n) {
  return {
    x: e.x + n.x,
    y: e.y + n.y
  };
}
function Ro(e, n) {
  return {
    x: e.x - n.x,
    y: e.y - n.y
  };
}
function ca(e, n) {
  if (e.side === "top" || e.side === "bottom") {
    const {
      side: t,
      align: a
    } = e, i = a === "left" ? 0 : a === "center" ? n.width / 2 : a === "right" ? n.width : a, l = t === "top" ? 0 : t === "bottom" ? n.height : t;
    return Yt({
      x: i,
      y: l
    }, n);
  } else if (e.side === "left" || e.side === "right") {
    const {
      side: t,
      align: a
    } = e, i = t === "left" ? 0 : t === "right" ? n.width : t, l = a === "top" ? 0 : a === "center" ? n.height / 2 : a === "bottom" ? n.height : a;
    return Yt({
      x: i,
      y: l
    }, n);
  }
  return Yt({
    x: n.width / 2,
    y: n.height / 2
  }, n);
}
const xi = {
  static: Fo,
  // specific viewport position, usually centered
  connected: jo
  // connected to a certain element
}, Ho = k({
  locationStrategy: {
    type: [String, Function],
    default: "static",
    validator: (e) => typeof e == "function" || e in xi
  },
  location: {
    type: String,
    default: "bottom"
  },
  origin: {
    type: String,
    default: "auto"
  },
  offset: [Number, String, Array]
}, "VOverlay-location-strategies");
function Do(e, n) {
  const t = j({}), a = j();
  Q && ut(() => !!(n.isActive.value && e.locationStrategy), (l) => {
    var r, o;
    R(() => e.locationStrategy, l), se(() => {
      window.removeEventListener("resize", i), a.value = void 0;
    }), window.addEventListener("resize", i, {
      passive: !0
    }), typeof e.locationStrategy == "function" ? a.value = (r = e.locationStrategy(n, e, t)) == null ? void 0 : r.updateLocation : a.value = (o = xi[e.locationStrategy](n, e, t)) == null ? void 0 : o.updateLocation;
  });
  function i(l) {
    var r;
    (r = a.value) == null || r.call(a, l);
  }
  return {
    contentStyles: t,
    updateLocation: a
  };
}
function Fo() {
}
function zo(e, n) {
  const t = Ta(e);
  return n ? t.x += parseFloat(e.style.right || 0) : t.x -= parseFloat(e.style.left || 0), t.y -= parseFloat(e.style.top || 0), t;
}
function jo(e, n, t) {
  (Array.isArray(e.target.value) || br(e.target.value)) && Object.assign(t.value, {
    position: "fixed",
    top: 0,
    [e.isRtl.value ? "right" : "left"]: 0
  });
  const {
    preferredAnchor: i,
    preferredOrigin: l
  } = Cn(() => {
    const b = an(n.location, e.isRtl.value), y = n.origin === "overlap" ? b : n.origin === "auto" ? Zt(b) : an(n.origin, e.isRtl.value);
    return b.side === y.side && b.align === Gt(y).align ? {
      preferredAnchor: Hn(b),
      preferredOrigin: Hn(y)
    } : {
      preferredAnchor: b,
      preferredOrigin: y
    };
  }), [r, o, s, u] = ["minWidth", "minHeight", "maxWidth", "maxHeight"].map((b) => g(() => {
    const y = parseFloat(n[b]);
    return isNaN(y) ? 1 / 0 : y;
  })), c = g(() => {
    if (Array.isArray(n.offset))
      return n.offset;
    if (typeof n.offset == "string") {
      const b = n.offset.split(" ").map(parseFloat);
      return b.length < 2 && b.push(0), b;
    }
    return typeof n.offset == "number" ? [n.offset, 0] : [0, 0];
  });
  let f = !1;
  const v = new ResizeObserver(() => {
    f && m();
  });
  R([e.target, e.contentEl], (b, y) => {
    let [h, L] = b, [p, x] = y;
    p && !Array.isArray(p) && v.unobserve(p), h && !Array.isArray(h) && v.observe(h), x && v.unobserve(x), L && v.observe(L);
  }, {
    immediate: !0
  }), se(() => {
    v.disconnect();
  });
  function m() {
    if (f = !1, requestAnimationFrame(() => f = !0), !e.target.value || !e.contentEl.value) return;
    const b = Pa(e.target.value), y = zo(e.contentEl.value, e.isRtl.value), h = kt(e.contentEl.value), L = 12;
    h.length || (h.push(document.documentElement), e.contentEl.value.style.top && e.contentEl.value.style.left || (y.x -= parseFloat(document.documentElement.style.getPropertyValue("--v-body-scroll-x") || 0), y.y -= parseFloat(document.documentElement.style.getPropertyValue("--v-body-scroll-y") || 0)));
    const p = h.reduce((V, S) => {
      const w = S.getBoundingClientRect(), P = new Ve({
        x: S === document.documentElement ? 0 : w.x,
        y: S === document.documentElement ? 0 : w.y,
        width: S.clientWidth,
        height: S.clientHeight
      });
      return V ? new Ve({
        x: Math.max(V.left, P.left),
        y: Math.max(V.top, P.top),
        width: Math.min(V.right, P.right) - Math.max(V.left, P.left),
        height: Math.min(V.bottom, P.bottom) - Math.max(V.top, P.top)
      }) : P;
    }, void 0);
    p.x += L, p.y += L, p.width -= L * 2, p.height -= L * 2;
    let x = {
      anchor: i.value,
      origin: l.value
    };
    function _(V) {
      const S = new Ve(y), w = ca(V.anchor, b), P = ca(V.origin, S);
      let {
        x: F,
        y: W
      } = Ro(w, P);
      switch (V.anchor.side) {
        case "top":
          W -= c.value[0];
          break;
        case "bottom":
          W += c.value[0];
          break;
        case "left":
          F -= c.value[0];
          break;
        case "right":
          F += c.value[0];
          break;
      }
      switch (V.anchor.align) {
        case "top":
          W -= c.value[1];
          break;
        case "bottom":
          W += c.value[1];
          break;
        case "left":
          F -= c.value[1];
          break;
        case "right":
          F += c.value[1];
          break;
      }
      return S.x += F, S.y += W, S.width = Math.min(S.width, s.value), S.height = Math.min(S.height, u.value), {
        overflows: Fn(S, p),
        x: F,
        y: W
      };
    }
    let O = 0, E = 0;
    const A = {
      x: 0,
      y: 0
    }, C = {
      x: !1,
      y: !1
    };
    let I = -1;
    for (; ; ) {
      if (I++ > 10) {
        lr("Infinite loop detected in connectedLocationStrategy");
        break;
      }
      const {
        x: V,
        y: S,
        overflows: w
      } = _(x);
      O += V, E += S, y.x += V, y.y += S;
      {
        const P = Dn(x.anchor), F = w.x.before || w.x.after, W = w.y.before || w.y.after;
        let ve = !1;
        if (["x", "y"].forEach((q) => {
          if (q === "x" && F && !C.x || q === "y" && W && !C.y) {
            const ie = {
              anchor: {
                ...x.anchor
              },
              origin: {
                ...x.origin
              }
            }, Ce = q === "x" ? P === "y" ? Gt : Zt : P === "y" ? Zt : Gt;
            ie.anchor = Ce(ie.anchor), ie.origin = Ce(ie.origin);
            const {
              overflows: pe
            } = _(ie);
            (pe[q].before <= w[q].before && pe[q].after <= w[q].after || pe[q].before + pe[q].after < (w[q].before + w[q].after) / 2) && (x = ie, ve = C[q] = !0);
          }
        }), ve) continue;
      }
      w.x.before && (O += w.x.before, y.x += w.x.before), w.x.after && (O -= w.x.after, y.x -= w.x.after), w.y.before && (E += w.y.before, y.y += w.y.before), w.y.after && (E -= w.y.after, y.y -= w.y.after);
      {
        const P = Fn(y, p);
        A.x = p.width - P.x.before - P.x.after, A.y = p.height - P.y.before - P.y.after, O += P.x.before, y.x += P.x.before, E += P.y.before, y.y += P.y.before;
      }
      break;
    }
    const $ = Dn(x.anchor);
    return Object.assign(t.value, {
      "--v-overlay-anchor-origin": `${x.anchor.side} ${x.anchor.align}`,
      transformOrigin: `${x.origin.side} ${x.origin.align}`,
      // transform: `translate(${pixelRound(x)}px, ${pixelRound(y)}px)`,
      top: T(Kt(E)),
      left: e.isRtl.value ? void 0 : T(Kt(O)),
      right: e.isRtl.value ? T(Kt(-O)) : void 0,
      minWidth: T($ === "y" ? Math.min(r.value, b.width) : r.value),
      maxWidth: T(da(nt(A.x, r.value === 1 / 0 ? 0 : r.value, s.value))),
      maxHeight: T(da(nt(A.y, o.value === 1 / 0 ? 0 : o.value, u.value)))
    }), {
      available: A,
      contentBox: y
    };
  }
  return R(() => [i.value, l.value, n.offset, n.minWidth, n.minHeight, n.maxWidth, n.maxHeight], () => m()), Ie(() => {
    const b = m();
    if (!b) return;
    const {
      available: y,
      contentBox: h
    } = b;
    h.height > y.y && requestAnimationFrame(() => {
      m(), requestAnimationFrame(() => {
        m();
      });
    });
  }), {
    updateLocation: m
  };
}
function Kt(e) {
  return Math.round(e * devicePixelRatio) / devicePixelRatio;
}
function da(e) {
  return Math.ceil(e * devicePixelRatio) / devicePixelRatio;
}
let dn = !0;
const Et = [];
function Wo(e) {
  !dn || Et.length ? (Et.push(e), fn()) : (dn = !1, e(), fn());
}
let fa = -1;
function fn() {
  cancelAnimationFrame(fa), fa = requestAnimationFrame(() => {
    const e = Et.shift();
    e && e(), Et.length ? fn() : dn = !0;
  });
}
const Lt = {
  none: null,
  close: Go,
  block: qo,
  reposition: Yo
}, Uo = k({
  scrollStrategy: {
    type: [String, Function],
    default: "block",
    validator: (e) => typeof e == "function" || e in Lt
  }
}, "VOverlay-scroll-strategies");
function Zo(e, n) {
  if (!Q) return;
  let t;
  Te(async () => {
    t == null || t.stop(), n.isActive.value && e.scrollStrategy && (t = gn(), await new Promise((a) => setTimeout(a)), t.active && t.run(() => {
      var a;
      typeof e.scrollStrategy == "function" ? e.scrollStrategy(n, e, t) : (a = Lt[e.scrollStrategy]) == null || a.call(Lt, n, e, t);
    }));
  }), se(() => {
    t == null || t.stop();
  });
}
function Go(e) {
  function n(t) {
    e.isActive.value = !1;
  }
  ki(e.targetEl.value ?? e.contentEl.value, n);
}
function qo(e, n) {
  var r;
  const t = (r = e.root.value) == null ? void 0 : r.offsetParent, a = [.../* @__PURE__ */ new Set([...kt(e.targetEl.value, n.contained ? t : void 0), ...kt(e.contentEl.value, n.contained ? t : void 0)])].filter((o) => !o.classList.contains("v-overlay-scroll-blocked")), i = window.innerWidth - document.documentElement.offsetWidth, l = ((o) => Sn(o) && o)(t || document.documentElement);
  l && e.root.value.classList.add("v-overlay--scroll-blocked"), a.forEach((o, s) => {
    o.style.setProperty("--v-body-scroll-x", T(-o.scrollLeft)), o.style.setProperty("--v-body-scroll-y", T(-o.scrollTop)), o !== document.documentElement && o.style.setProperty("--v-scrollbar-offset", T(i)), o.classList.add("v-overlay-scroll-blocked");
  }), se(() => {
    a.forEach((o, s) => {
      const u = parseFloat(o.style.getPropertyValue("--v-body-scroll-x")), c = parseFloat(o.style.getPropertyValue("--v-body-scroll-y")), f = o.style.scrollBehavior;
      o.style.scrollBehavior = "auto", o.style.removeProperty("--v-body-scroll-x"), o.style.removeProperty("--v-body-scroll-y"), o.style.removeProperty("--v-scrollbar-offset"), o.classList.remove("v-overlay-scroll-blocked"), o.scrollLeft = -u, o.scrollTop = -c, o.style.scrollBehavior = f;
    }), l && e.root.value.classList.remove("v-overlay--scroll-blocked");
  });
}
function Yo(e, n, t) {
  let a = !1, i = -1, l = -1;
  function r(o) {
    Wo(() => {
      var c, f;
      const s = performance.now();
      (f = (c = e.updateLocation).value) == null || f.call(c, o), a = (performance.now() - s) / (1e3 / 60) > 2;
    });
  }
  l = (typeof requestIdleCallback > "u" ? (o) => o() : requestIdleCallback)(() => {
    t.run(() => {
      ki(e.targetEl.value ?? e.contentEl.value, (o) => {
        a ? (cancelAnimationFrame(i), i = requestAnimationFrame(() => {
          i = requestAnimationFrame(() => {
            r(o);
          });
        })) : r(o);
      });
    });
  }), se(() => {
    typeof cancelIdleCallback < "u" && cancelIdleCallback(l), cancelAnimationFrame(i);
  });
}
function ki(e, n) {
  const t = [document, ...kt(e)];
  t.forEach((a) => {
    a.addEventListener("scroll", n, {
      passive: !0
    });
  }), se(() => {
    t.forEach((a) => {
      a.removeEventListener("scroll", n);
    });
  });
}
const vn = Symbol.for("vuetify:v-menu"), Ko = k({
  closeDelay: [Number, String],
  openDelay: [Number, String]
}, "delay");
function Xo(e, n) {
  let t = () => {
  };
  function a(r) {
    t == null || t();
    const o = Number(r ? e.openDelay : e.closeDelay);
    return new Promise((s) => {
      t = Gl(o, () => {
        n == null || n(r), s(r);
      });
    });
  }
  function i() {
    return a(!0);
  }
  function l() {
    return a(!1);
  }
  return {
    clearDelay: t,
    runOpenDelay: i,
    runCloseDelay: l
  };
}
const Jo = k({
  target: [String, Object],
  activator: [String, Object],
  activatorProps: {
    type: Object,
    default: () => ({})
  },
  openOnClick: {
    type: Boolean,
    default: void 0
  },
  openOnHover: Boolean,
  openOnFocus: {
    type: Boolean,
    default: void 0
  },
  closeOnContentClick: Boolean,
  ...Ko()
}, "VOverlay-activator");
function Qo(e, n) {
  let {
    isActive: t,
    isTop: a,
    contentEl: i
  } = n;
  const l = G("useActivator"), r = j();
  let o = !1, s = !1, u = !0;
  const c = g(() => e.openOnFocus || e.openOnFocus == null && e.openOnHover), f = g(() => e.openOnClick || e.openOnClick == null && !e.openOnHover && !c.value), {
    runOpenDelay: v,
    runCloseDelay: m
  } = Xo(e, (C) => {
    C === (e.openOnHover && o || c.value && s) && !(e.openOnHover && t.value && !a.value) && (t.value !== C && (u = !0), t.value = C);
  }), b = j(), y = {
    onClick: (C) => {
      C.stopPropagation(), r.value = C.currentTarget || C.target, t.value || (b.value = [C.clientX, C.clientY]), t.value = !t.value;
    },
    onMouseenter: (C) => {
      var I;
      (I = C.sourceCapabilities) != null && I.firesTouchEvents || (o = !0, r.value = C.currentTarget || C.target, v());
    },
    onMouseleave: (C) => {
      o = !1, m();
    },
    onFocus: (C) => {
      Zl(C.target, ":focus-visible") !== !1 && (s = !0, C.stopPropagation(), r.value = C.currentTarget || C.target, v());
    },
    onBlur: (C) => {
      s = !1, C.stopPropagation(), m();
    }
  }, h = g(() => {
    const C = {};
    return f.value && (C.onClick = y.onClick), e.openOnHover && (C.onMouseenter = y.onMouseenter, C.onMouseleave = y.onMouseleave), c.value && (C.onFocus = y.onFocus, C.onBlur = y.onBlur), C;
  }), L = g(() => {
    const C = {};
    if (e.openOnHover && (C.onMouseenter = () => {
      o = !0, v();
    }, C.onMouseleave = () => {
      o = !1, m();
    }), c.value && (C.onFocusin = () => {
      s = !0, v();
    }, C.onFocusout = () => {
      s = !1, m();
    }), e.closeOnContentClick) {
      const I = oe(vn, null);
      C.onClick = () => {
        t.value = !1, I == null || I.closeParents();
      };
    }
    return C;
  }), p = g(() => {
    const C = {};
    return e.openOnHover && (C.onMouseenter = () => {
      u && (o = !0, u = !1, v());
    }, C.onMouseleave = () => {
      o = !1, m();
    }), C;
  });
  R(a, (C) => {
    var I;
    C && (e.openOnHover && !o && (!c.value || !s) || c.value && !s && (!e.openOnHover || !o)) && !((I = i.value) != null && I.contains(document.activeElement)) && (t.value = !1);
  }), R(t, (C) => {
    C || setTimeout(() => {
      b.value = void 0;
    });
  }, {
    flush: "post"
  });
  const x = nn();
  Te(() => {
    x.value && Ie(() => {
      r.value = x.el;
    });
  });
  const _ = nn(), O = g(() => e.target === "cursor" && b.value ? b.value : _.value ? _.el : _i(e.target, l) || r.value), E = g(() => Array.isArray(O.value) ? void 0 : O.value);
  let A;
  return R(() => !!e.activator, (C) => {
    C && Q ? (A = gn(), A.run(() => {
      es(e, l, {
        activatorEl: r,
        activatorEvents: h
      });
    })) : A && A.stop();
  }, {
    flush: "post",
    immediate: !0
  }), se(() => {
    A == null || A.stop();
  }), {
    activatorEl: r,
    activatorRef: x,
    target: O,
    targetEl: E,
    targetRef: _,
    activatorEvents: h,
    contentEvents: L,
    scrimEvents: p
  };
}
function es(e, n, t) {
  let {
    activatorEl: a,
    activatorEvents: i
  } = t;
  R(() => e.activator, (s, u) => {
    if (u && s !== u) {
      const c = o(u);
      c && r(c);
    }
    s && Ie(() => l());
  }, {
    immediate: !0
  }), R(() => e.activatorProps, () => {
    l();
  }), se(() => {
    r();
  });
  function l() {
    let s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : o(), u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e.activatorProps;
    s && Kl(s, Z(i.value, u));
  }
  function r() {
    let s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : o(), u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e.activatorProps;
    s && Xl(s, Z(i.value, u));
  }
  function o() {
    let s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : e.activator;
    const u = _i(s, n);
    return a.value = (u == null ? void 0 : u.nodeType) === Node.ELEMENT_NODE ? u : void 0, a.value;
  }
}
function _i(e, n) {
  var a, i;
  if (!e) return;
  let t;
  if (e === "parent") {
    let l = (i = (a = n == null ? void 0 : n.proxy) == null ? void 0 : a.$el) == null ? void 0 : i.parentNode;
    for (; l != null && l.hasAttribute("data-no-activator"); )
      l = l.parentNode;
    t = l;
  } else typeof e == "string" ? t = document.querySelector(e) : "$el" in e ? t = e.$el : t = e;
  return t;
}
function ts() {
  if (!Q) return H(!1);
  const {
    ssr: e
  } = so();
  if (e) {
    const n = H(!1);
    return st(() => {
      n.value = !0;
    }), n;
  } else
    return H(!0);
}
const ns = k({
  eager: Boolean
}, "lazy");
function as(e, n) {
  const t = H(!1), a = g(() => t.value || e.eager || n.value);
  R(n, () => t.value = !0);
  function i() {
    e.eager || (t.value = !1);
  }
  return {
    isBooted: t,
    hasContent: a,
    onAfterLeave: i
  };
}
function Vi() {
  const n = G("useScopeId").vnode.scopeId;
  return {
    scopeId: n ? {
      [n]: ""
    } : void 0
  };
}
const va = Symbol.for("vuetify:stack"), Ye = le([]);
function is(e, n, t) {
  const a = G("useStack"), i = !t, l = oe(va, void 0), r = le({
    activeChildren: /* @__PURE__ */ new Set()
  });
  he(va, r);
  const o = H(+n.value);
  ut(e, () => {
    var f;
    const c = (f = Ye.at(-1)) == null ? void 0 : f[1];
    o.value = c ? c + 10 : +n.value, i && Ye.push([a.uid, o.value]), l == null || l.activeChildren.add(a.uid), se(() => {
      if (i) {
        const v = La(Ye).findIndex((m) => m[0] === a.uid);
        Ye.splice(v, 1);
      }
      l == null || l.activeChildren.delete(a.uid);
    });
  });
  const s = H(!0);
  i && Te(() => {
    var f;
    const c = ((f = Ye.at(-1)) == null ? void 0 : f[0]) === a.uid;
    setTimeout(() => s.value = c);
  });
  const u = g(() => !r.activeChildren.size);
  return {
    globalTop: Pt(s),
    localTop: u,
    stackStyles: g(() => ({
      zIndex: o.value
    }))
  };
}
function ls(e) {
  return {
    teleportTarget: g(() => {
      const t = e();
      if (t === !0 || !Q) return;
      const a = t === !1 ? document.body : typeof t == "string" ? document.querySelector(t) : t;
      if (a == null) {
        mn(`Unable to locate target ${t}`);
        return;
      }
      let i = [...a.children].find((l) => l.matches(".v-overlay-container"));
      return i || (i = document.createElement("div"), i.className = "v-overlay-container", a.appendChild(i)), i;
    })
  };
}
function rs() {
  return !0;
}
function Ei(e, n, t) {
  if (!e || Ai(e, t) === !1) return !1;
  const a = Ma(n);
  if (typeof ShadowRoot < "u" && a instanceof ShadowRoot && a.host === e.target) return !1;
  const i = (typeof t.value == "object" && t.value.include || (() => []))();
  return i.push(n), !i.some((l) => l == null ? void 0 : l.contains(e.target));
}
function Ai(e, n) {
  return (typeof n.value == "object" && n.value.closeConditional || rs)(e);
}
function os(e, n, t) {
  const a = typeof t.value == "function" ? t.value : t.value.handler;
  e.shadowTarget = e.target, n._clickOutside.lastMousedownWasOutside && Ei(e, n, t) && setTimeout(() => {
    Ai(e, t) && a && a(e);
  }, 0);
}
function ma(e, n) {
  const t = Ma(e);
  n(document), typeof ShadowRoot < "u" && t instanceof ShadowRoot && n(t);
}
const ss = {
  // [data-app] may not be found
  // if using bind, inserted makes
  // sure that the root element is
  // available, iOS does not support
  // clicks on body
  mounted(e, n) {
    const t = (i) => os(i, e, n), a = (i) => {
      e._clickOutside.lastMousedownWasOutside = Ei(i, e, n);
    };
    ma(e, (i) => {
      i.addEventListener("click", t, !0), i.addEventListener("mousedown", a, !0);
    }), e._clickOutside || (e._clickOutside = {
      lastMousedownWasOutside: !1
    }), e._clickOutside[n.instance.$.uid] = {
      onClick: t,
      onMousedown: a
    };
  },
  beforeUnmount(e, n) {
    e._clickOutside && (ma(e, (t) => {
      var l;
      if (!t || !((l = e._clickOutside) != null && l[n.instance.$.uid])) return;
      const {
        onClick: a,
        onMousedown: i
      } = e._clickOutside[n.instance.$.uid];
      t.removeEventListener("click", a, !0), t.removeEventListener("mousedown", i, !0);
    }), delete e._clickOutside[n.instance.$.uid]);
  }
};
function us(e) {
  const {
    modelValue: n,
    color: t,
    ...a
  } = e;
  return d(Ae, {
    name: "fade-transition",
    appear: !0
  }, {
    default: () => [e.modelValue && d("div", Z({
      class: ["v-overlay__scrim", e.color.backgroundColorClasses.value],
      style: e.color.backgroundColorStyles.value
    }, a), null)]
  });
}
const Pi = k({
  absolute: Boolean,
  attach: [Boolean, String, Object],
  closeOnBack: {
    type: Boolean,
    default: !0
  },
  contained: Boolean,
  contentClass: null,
  contentProps: null,
  disabled: Boolean,
  opacity: [Number, String],
  noClickAnimation: Boolean,
  modelValue: Boolean,
  persistent: Boolean,
  scrim: {
    type: [Boolean, String],
    default: !0
  },
  zIndex: {
    type: [Number, String],
    default: 2e3
  },
  ...Jo(),
  ...z(),
  ...We(),
  ...ns(),
  ...Ho(),
  ...Uo(),
  ...de(),
  ...ja()
}, "VOverlay"), ga = M()({
  name: "VOverlay",
  directives: {
    ClickOutside: ss
  },
  inheritAttrs: !1,
  props: {
    _disableGlobalStack: Boolean,
    ...Pi()
  },
  emits: {
    "click:outside": (e) => !0,
    "update:modelValue": (e) => !0,
    afterEnter: () => !0,
    afterLeave: () => !0
  },
  setup(e, n) {
    let {
      slots: t,
      attrs: a,
      emit: i
    } = n;
    const l = G("VOverlay"), r = j(), o = j(), s = j(), u = ct(e, "modelValue"), c = g({
      get: () => u.value,
      set: (N) => {
        N && e.disabled || (u.value = N);
      }
    }), {
      themeClasses: f
    } = fe(e), {
      rtlClasses: v,
      isRtl: m
    } = Ze(), {
      hasContent: b,
      onAfterLeave: y
    } = as(e, c), h = Fe(g(() => typeof e.scrim == "string" ? e.scrim : null)), {
      globalTop: L,
      localTop: p,
      stackStyles: x
    } = is(c, Y(e, "zIndex"), e._disableGlobalStack), {
      activatorEl: _,
      activatorRef: O,
      target: E,
      targetEl: A,
      targetRef: C,
      activatorEvents: I,
      contentEvents: $,
      scrimEvents: V
    } = Qo(e, {
      isActive: c,
      isTop: p,
      contentEl: s
    }), {
      teleportTarget: S
    } = ls(() => {
      var K, Me, Pn;
      const N = e.attach || e.contained;
      if (N) return N;
      const J = ((K = _ == null ? void 0 : _.value) == null ? void 0 : K.getRootNode()) || ((Pn = (Me = l.proxy) == null ? void 0 : Me.$el) == null ? void 0 : Pn.getRootNode());
      return J instanceof ShadowRoot ? J : !1;
    }), {
      dimensionStyles: w
    } = Ue(e), P = ts(), {
      scopeId: F
    } = Vi();
    R(() => e.disabled, (N) => {
      N && (c.value = !1);
    });
    const {
      contentStyles: W,
      updateLocation: ve
    } = Do(e, {
      isRtl: m,
      contentEl: s,
      target: E,
      isActive: c
    });
    Zo(e, {
      root: r,
      contentEl: s,
      targetEl: A,
      isActive: c,
      updateLocation: ve
    });
    function q(N) {
      i("click:outside", N), e.persistent ? Le() : c.value = !1;
    }
    function ie(N) {
      return c.value && L.value && // If using scrim, only close if clicking on it rather than anything opened on top
      (!e.scrim || N.target === o.value || N instanceof MouseEvent && N.shadowTarget === o.value);
    }
    Q && R(c, (N) => {
      N ? window.addEventListener("keydown", Ce) : window.removeEventListener("keydown", Ce);
    }, {
      immediate: !0
    }), be(() => {
      Q && window.removeEventListener("keydown", Ce);
    });
    function Ce(N) {
      var J, K;
      N.key === "Escape" && L.value && (e.persistent ? Le() : (c.value = !1, (J = s.value) != null && J.contains(document.activeElement) && ((K = _.value) == null || K.focus())));
    }
    const pe = Xr();
    ut(() => e.closeOnBack, () => {
      Jr(pe, (N) => {
        L.value && c.value ? (N(!1), e.persistent ? Le() : c.value = !1) : N();
      });
    });
    const Se = j();
    R(() => c.value && (e.absolute || e.contained) && S.value == null, (N) => {
      if (N) {
        const J = yr(r.value);
        J && J !== document.scrollingElement && (Se.value = J.scrollTop);
      }
    });
    function Le() {
      e.noClickAnimation || s.value && Ke(s.value, [{
        transformOrigin: "center"
      }, {
        transform: "scale(1.03)"
      }, {
        transformOrigin: "center"
      }], {
        duration: 150,
        easing: rn
      });
    }
    function jt() {
      i("afterEnter");
    }
    function qe() {
      y(), i("afterLeave");
    }
    return D(() => {
      var N;
      return d(ge, null, [(N = t.activator) == null ? void 0 : N.call(t, {
        isActive: c.value,
        targetRef: C,
        props: Z({
          ref: O
        }, I.value, e.activatorProps)
      }), P.value && b.value && d(Gi, {
        disabled: !S.value,
        to: S.value
      }, {
        default: () => [d("div", Z({
          class: ["v-overlay", {
            "v-overlay--absolute": e.absolute || e.contained,
            "v-overlay--active": c.value,
            "v-overlay--contained": e.contained
          }, f.value, v.value, e.class],
          style: [x.value, {
            "--v-overlay-opacity": e.opacity,
            top: T(Se.value)
          }, e.style],
          ref: r
        }, F, a), [d(us, Z({
          color: h,
          modelValue: c.value && !!e.scrim,
          ref: o
        }, V.value), null), d(Je, {
          appear: !0,
          persisted: !0,
          transition: e.transition,
          target: E.value,
          onAfterEnter: jt,
          onAfterLeave: qe
        }, {
          default: () => {
            var J;
            return [tt(d("div", Z({
              ref: s,
              class: ["v-overlay__content", e.contentClass],
              style: [w.value, W.value]
            }, $.value, e.contentProps), [(J = t.default) == null ? void 0 : J.call(t, {
              isActive: c
            })]), [[wa, c.value], [yn("click-outside"), {
              handler: q,
              closeConditional: ie,
              include: () => [_.value]
            }]])];
          }
        })])]
      })]);
    }), {
      activatorEl: _,
      scrimEl: o,
      target: E,
      animateClick: Le,
      contentEl: s,
      globalTop: L,
      localTop: p,
      updateLocation: ve
    };
  }
}), Xt = Symbol("Forwarded refs");
function Jt(e, n) {
  let t = e;
  for (; t; ) {
    const a = Reflect.getOwnPropertyDescriptor(t, n);
    if (a) return a;
    t = Object.getPrototypeOf(t);
  }
}
function cs(e) {
  for (var n = arguments.length, t = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
    t[a - 1] = arguments[a];
  return e[Xt] = t, new Proxy(e, {
    get(i, l) {
      if (Reflect.has(i, l))
        return Reflect.get(i, l);
      if (!(typeof l == "symbol" || l.startsWith("$") || l.startsWith("__"))) {
        for (const r of t)
          if (r.value && Reflect.has(r.value, l)) {
            const o = Reflect.get(r.value, l);
            return typeof o == "function" ? o.bind(r.value) : o;
          }
      }
    },
    has(i, l) {
      if (Reflect.has(i, l))
        return !0;
      if (typeof l == "symbol" || l.startsWith("$") || l.startsWith("__")) return !1;
      for (const r of t)
        if (r.value && Reflect.has(r.value, l))
          return !0;
      return !1;
    },
    set(i, l, r) {
      if (Reflect.has(i, l))
        return Reflect.set(i, l, r);
      if (typeof l == "symbol" || l.startsWith("$") || l.startsWith("__")) return !1;
      for (const o of t)
        if (o.value && Reflect.has(o.value, l))
          return Reflect.set(o.value, l, r);
      return !1;
    },
    getOwnPropertyDescriptor(i, l) {
      var o;
      const r = Reflect.getOwnPropertyDescriptor(i, l);
      if (r) return r;
      if (!(typeof l == "symbol" || l.startsWith("$") || l.startsWith("__"))) {
        for (const s of t) {
          if (!s.value) continue;
          const u = Jt(s.value, l) ?? ("_" in s.value ? Jt((o = s.value._) == null ? void 0 : o.setupState, l) : void 0);
          if (u) return u;
        }
        for (const s of t) {
          const u = s.value && s.value[Xt];
          if (!u) continue;
          const c = u.slice();
          for (; c.length; ) {
            const f = c.shift(), v = Jt(f.value, l);
            if (v) return v;
            const m = f.value && f.value[Xt];
            m && c.push(...m);
          }
        }
      }
    }
  });
}
const ds = k({
  // TODO
  // disableKeys: Boolean,
  id: String,
  submenu: Boolean,
  ...zl(Pi({
    closeDelay: 250,
    closeOnContentClick: !0,
    locationStrategy: "connected",
    location: void 0,
    openDelay: 300,
    scrim: !1,
    scrollStrategy: "reposition",
    transition: {
      component: $o
    }
  }), ["absolute"])
}, "VMenu"), Ti = M()({
  name: "VMenu",
  props: ds(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, n) {
    let {
      slots: t
    } = n;
    const a = ct(e, "modelValue"), {
      scopeId: i
    } = Vi(), {
      isRtl: l
    } = Ze(), r = It(), o = g(() => e.id || `v-menu-${r}`), s = j(), u = oe(vn, null), c = H(/* @__PURE__ */ new Set());
    he(vn, {
      register() {
        c.value.add(r);
      },
      unregister() {
        c.value.delete(r);
      },
      closeParents(h) {
        setTimeout(() => {
          var L;
          !c.value.size && !e.persistent && (h == null || (L = s.value) != null && L.contentEl && !ql(h, s.value.contentEl)) && (a.value = !1, u == null || u.closeParents());
        }, 40);
      }
    }), be(() => {
      u == null || u.unregister(), document.removeEventListener("focusin", f);
    }), Sa(() => a.value = !1);
    async function f(h) {
      var x, _, O;
      const L = h.relatedTarget, p = h.target;
      await Ie(), a.value && L !== p && ((x = s.value) != null && x.contentEl) && // We're the topmost menu
      ((_ = s.value) != null && _.globalTop) && // It isn't the document or the menu body
      ![document, s.value.contentEl].includes(p) && // It isn't inside the menu body
      !s.value.contentEl.contains(p) && ((O = tn(s.value.contentEl)[0]) == null || O.focus());
    }
    R(a, (h) => {
      h ? (u == null || u.register(), Q && document.addEventListener("focusin", f, {
        once: !0
      })) : (u == null || u.unregister(), Q && document.removeEventListener("focusin", f));
    }, {
      immediate: !0
    });
    function v(h) {
      u == null || u.closeParents(h);
    }
    function m(h) {
      var L, p, x, _, O;
      if (!e.disabled)
        if (h.key === "Tab" || h.key === "Enter" && !e.closeOnContentClick) {
          if (h.key === "Enter" && (h.target instanceof HTMLTextAreaElement || h.target instanceof HTMLInputElement && h.target.closest("form"))) return;
          h.key === "Enter" && h.preventDefault(), Ea(tn((L = s.value) == null ? void 0 : L.contentEl, !1), h.shiftKey ? "prev" : "next", (A) => A.tabIndex >= 0) || (a.value = !1, (x = (p = s.value) == null ? void 0 : p.activatorEl) == null || x.focus());
        } else e.submenu && h.key === (l.value ? "ArrowRight" : "ArrowLeft") && (a.value = !1, (O = (_ = s.value) == null ? void 0 : _.activatorEl) == null || O.focus());
    }
    function b(h) {
      var p;
      if (e.disabled) return;
      const L = (p = s.value) == null ? void 0 : p.contentEl;
      L && a.value ? h.key === "ArrowDown" ? (h.preventDefault(), h.stopImmediatePropagation(), Ct(L, "next")) : h.key === "ArrowUp" ? (h.preventDefault(), h.stopImmediatePropagation(), Ct(L, "prev")) : e.submenu && (h.key === (l.value ? "ArrowRight" : "ArrowLeft") ? a.value = !1 : h.key === (l.value ? "ArrowLeft" : "ArrowRight") && (h.preventDefault(), Ct(L, "first"))) : (e.submenu ? h.key === (l.value ? "ArrowLeft" : "ArrowRight") : ["ArrowDown", "ArrowUp"].includes(h.key)) && (a.value = !0, h.preventDefault(), setTimeout(() => setTimeout(() => b(h))));
    }
    const y = g(() => Z({
      "aria-haspopup": "menu",
      "aria-expanded": String(a.value),
      "aria-owns": o.value,
      onKeydown: b
    }, e.activatorProps));
    return D(() => {
      const h = ga.filterProps(e);
      return d(ga, Z({
        ref: s,
        id: o.value,
        class: ["v-menu", e.class],
        style: e.style
      }, h, {
        modelValue: a.value,
        "onUpdate:modelValue": (L) => a.value = L,
        absolute: !0,
        activatorProps: y.value,
        location: e.location ?? (e.submenu ? "end" : "bottom"),
        "onClick:outside": v,
        onKeydown: m
      }, i), {
        activator: t.activator,
        default: function() {
          for (var L = arguments.length, p = new Array(L), x = 0; x < L; x++)
            p[x] = arguments[x];
          return d(re, {
            root: "VMenu"
          }, {
            default: () => {
              var _;
              return [(_ = t.default) == null ? void 0 : _.call(t, ...p)];
            }
          });
        }
      });
    }), cs({
      id: o,
      ΨopenChildren: c
    }, s);
  }
}), Ii = /* @__PURE__ */ we({
  __name: "AppSwitcher",
  props: {
    apps: { default: () => [] }
  },
  setup(e) {
    const n = e;
    return (t, a) => (U(), ee(mt, {
      icon: "",
      "aria-label": "App switcher menu"
    }, {
      default: B(() => [
        d(ce, { icon: "$appSwitcher" }),
        d(Ti, {
          activator: "parent",
          transition: "slide-y-transition",
          "close-on-content-click": !1
        }, {
          default: B(() => [
            d(wo, {
              apps: n.apps
            }, null, 8, ["apps"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), Qt = j(!1);
function fs() {
  function e() {
    Qt.value = !Qt.value;
  }
  return {
    isMenuActive: Qt,
    toggleMenu: e
  };
}
const vs = {
  collapse: "svg:M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z",
  complete: "svg:M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z",
  cancel: "svg:M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z",
  close: "svg:M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z",
  delete: "svg:M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z",
  // delete (e.g. v-chip close)
  clear: "svg:M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z",
  success: "svg:M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M11,16.5L18,9.5L16.59,8.09L11,13.67L7.91,10.59L6.5,12L11,16.5Z",
  info: "svg:M13,9H11V7H13M13,17H11V11H13M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  warning: "svg:M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z",
  error: "svg:M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z",
  prev: "svg:M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z",
  next: "svg:M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z",
  checkboxOn: "svg:M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z",
  checkboxOff: "svg:M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z",
  checkboxIndeterminate: "svg:M17,13H7V11H17M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z",
  delimiter: "svg:M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  // for carousel
  sortAsc: "svg:M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z",
  sortDesc: "svg:M11,4H13V16L18.5,10.5L19.92,11.92L12,19.84L4.08,11.92L5.5,10.5L11,16V4Z",
  expand: "svg:M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z",
  menu: "svg:M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z",
  subgroup: "svg:M7,10L12,15L17,10H7Z",
  dropdown: "svg:M7,10L12,15L17,10H7Z",
  radioOn: "svg:M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,7C9.24,7 7,9.24 7,12C7,14.76 9.24,17 12,17C14.76,17 17,14.76 17,12C17,9.24 14.76,7 12,7Z",
  radioOff: "svg:M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  edit: "svg:M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z",
  ratingEmpty: "svg:M12,15.39L8.24,17.66L9.23,13.38L5.91,10.5L10.29,10.13L12,6.09L13.71,10.13L18.09,10.5L14.77,13.38L15.76,17.66M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z",
  ratingFull: "svg:M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z",
  ratingHalf: "svg:M12,15.4V6.1L13.71,10.13L18.09,10.5L14.77,13.39L15.76,17.67M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z",
  loading: "svg:M19,8L15,12H18C18,15.31 15.31,18 12,18C11,18 10.03,17.75 9.2,17.3L7.74,18.76C8.97,19.54 10.43,20 12,20C16.42,20 20,16.42 20,12H23M6,12C6,8.69 8.69,6 12,6C13,6 13.97,6.25 14.8,6.7L16.26,5.24C15.03,4.46 13.57,4 12,4C7.58,4 4,7.58 4,12H1L5,16L9,12",
  first: "svg:M18.41,16.59L13.82,12L18.41,7.41L17,6L11,12L17,18L18.41,16.59M6,6H8V18H6V6Z",
  last: "svg:M5.59,7.41L10.18,12L5.59,16.59L7,18L13,12L7,6L5.59,7.41M16,6H18V18H16V6Z",
  unfold: "svg:M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z",
  file: "svg:M16.5,6V17.5C16.5,19.71 14.71,21.5 12.5,21.5C10.29,21.5 8.5,19.71 8.5,17.5V5C8.5,3.62 9.62,2.5 11,2.5C12.38,2.5 13.5,3.62 13.5,5V15.5C13.5,16.05 13.05,16.5 12.5,16.5C11.95,16.5 11.5,16.05 11.5,15.5V6H10V15.5C10,16.88 11.12,18 12.5,18C13.88,18 15,16.88 15,15.5V5C15,2.79 13.21,1 11,1C8.79,1 7,2.79 7,5V17.5C7,20.54 9.46,23 12.5,23C15.54,23 18,20.54 18,17.5V6H16.5Z",
  plus: "svg:M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z",
  minus: "svg:M19,13H5V11H19V13Z",
  calendar: "svg:M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z",
  treeviewCollapse: "svg:M7,10L12,15L17,10H7Z",
  treeviewExpand: "svg:M10,17L15,12L10,7V17Z",
  eyeDropper: "svg:M19.35,11.72L17.22,13.85L15.81,12.43L8.1,20.14L3.5,22L2,20.5L3.86,15.9L11.57,8.19L10.15,6.78L12.28,4.65L19.35,11.72M16.76,3C17.93,1.83 19.83,1.83 21,3C22.17,4.17 22.17,6.07 21,7.24L19.08,9.16L14.84,4.92L16.76,3M5.56,17.03L4.5,19.5L6.97,18.44L14.4,11L13,9.6L5.56,17.03Z"
}, ms = {
  component: Fa
};
function gs() {
  return {
    aliases: {
      ...vs,
      // Directions
      up: Yi,
      down: Ki,
      // Pages
      home: Xi,
      settings: Ji,
      // Account
      account: gt,
      signOut: Qi,
      appSwitcher: el,
      // Actions
      search: tl,
      refresh: nl,
      call: al,
      edit: il,
      create: ll,
      close: Wt,
      email: rl,
      delete: ol,
      history: sl,
      // Entities
      calendar: ul,
      client: gt,
      clients: yt,
      complaints: cl,
      customerPortal: Tn,
      customerPortals: Tn,
      graph: dl,
      mapMarker: fl,
      partner: gt,
      partners: yt,
      policySchedule: vl,
      policySchedules: ml,
      repudiationReason: gl,
      retention: yl,
      stream: hl,
      tag: bl,
      tags: Cl,
      team: yt,
      teams: yt,
      template: pl,
      ticket: Sl,
      user: gt,
      users: Ll,
      // Statuses
      status: wl,
      info: xl,
      success: In,
      warning: On,
      error: Wt,
      off: Wt,
      on: In,
      indeterminate: On,
      abandoned: kl,
      // Environments
      "env-development": _l,
      "env-uat": Vl,
      "env-beta": El,
      "env-production": Al,
      // Themes
      "theme-light": Pl,
      "theme-dark": Tl,
      // Jobs
      emergency: Il,
      engineer: Ol,
      healthAndSafety: Bl,
      material: Ml,
      returnVisit: $l,
      trade: Nl,
      vulnerability: Rl
    },
    sets: {
      mdi: ms
    },
    defaultSet: "mdi"
  };
}
var ue = /* @__PURE__ */ ((e) => (e.Light = "light", e.Dark = "dark", e))(ue || {});
function ys() {
  const e = {
    // Generic Statuses
    error: "#e6203a",
    on: "#4caf50",
    off: "#e6203a",
    indeterminate: "#fb8c00",
    // Environments
    development: "#2196f3",
    uat: "#ffde3b",
    beta: "#fb8c00",
    production: "#4caf50",
    // Branding
    cet: "#9966ff",
    // Job Statuses
    "status-Pending": "#e6203a",
    "status-Accepted": "#2196f3",
    "status-AutoDeploying": "#2196f3",
    "status-Unavailable": "#e6203a",
    "status-InProgress": "#ff9800",
    "status-Cancelled": "#e6203a",
    "status-Completed": "#4caf50",
    // Vulnerability / Health levels etc.
    "level-None": "#69a1be",
    "level-None-variant": "#69a1be",
    "level-Low": "#69a1be",
    "level-Low-variant": "#69a1be",
    "level-Medium": "#ff9800",
    "level-Medium-variant": "#ff9800",
    "level-High": "#e6203a",
    "level-High-variant": "#e6203a"
  };
  return {
    defaultTheme: "dark",
    themes: {
      light: {
        dark: !1,
        colors: {
          ...e,
          primary: "#3b82f6",
          secondary: "#a855f7",
          background: "#f1f4f7",
          "on-background": "#34455f",
          surface: "#fff",
          "on-surface": "#34455f",
          "surface-light": "#eaeef3",
          "on-surface-light": "#34455f",
          "surface-variant": "#34455f",
          "on-surface-variant": "#eef",
          "level-Low-variant": "#d0dfe7",
          "level-Medium-variant": "#ffebcc",
          "level-High-variant": "#fccfcf"
        }
      },
      dark: {
        dark: !0,
        colors: {
          ...e,
          primary: "#00ffa1",
          secondary: "#a855f7",
          background: "#0e101b",
          "on-background": "#cbd2ea",
          surface: "#191d2b",
          "on-surface": "#cbd2ea",
          "surface-light": "#282c3d",
          "on-surface-light": "#cbd2ea",
          "surface-variant": "#a8b3d2",
          "on-surface-variant": "#1f2533",
          "surface-bright": "#fff"
        }
      }
    }
  };
}
function hs() {
  return {
    VApp: {
      class: "simplifi"
    },
    VDialog: {
      persistent: !0,
      maxWidth: "50rem",
      transition: "slide-y-reverse-transition"
    },
    VOverlay: {
      class: "simplifi"
    },
    VProgressCircular: {
      color: "primary",
      indeterminate: !0
    },
    VProgressLinear: {
      color: "primary",
      indeterminate: !0,
      rounded: !0
    },
    VTooltip: {
      activator: "parent",
      location: "top",
      openDelay: "100"
    },
    // Forms
    VAutocomplete: { color: "primary", clearable: !0 },
    VCheckbox: {
      color: "primary",
      ripple: !1
    },
    VRadioGroup: {
      color: "primary",
      ripple: !1
    },
    VRadio: {
      color: "primary",
      ripple: !1
    },
    VRangeSlider: {
      color: "primary",
      trackColor: "",
      thumbLabel: "always"
    },
    VSelect: { color: "primary" },
    VSelectionControl: {
      ripple: !1
    },
    VSwitch: {
      color: "primary",
      ripple: !1,
      inset: !0
    },
    VTextarea: { color: "primary" },
    VTextField: { color: "primary" }
  };
}
function Oi(e, n) {
  const t = e, a = n;
  if (!n)
    return t;
  for (const i in a || {}) {
    const l = i, r = t[l];
    ha(r) ? ha(a[i]) ? t[l] = r.concat(a[i]) : t[l] = a[i] : ya(r) ? ya(a[i]) ? Oi(r, a[i]) : t[l] = a[i] : t[l] = a[l];
  }
  return t;
}
function ya(e) {
  return e && typeof e == "object" && !Array.isArray(e);
}
function ha(e) {
  return e && Array.isArray(e);
}
const At = "theme", Bi = () => {
  const e = window.localStorage.getItem(At);
  if (e)
    return e;
  let n = ue.Light;
  return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches && (n = ue.Dark), window.localStorage.setItem(At, n), n;
}, ke = j(Bi());
function zs() {
  ke.value = Bi();
}
const en = {
  [ue.Light]: {
    name: ue.Light,
    icon: "$theme-light",
    color: "#ff9742"
  },
  [ue.Dark]: {
    name: ue.Dark,
    icon: "$theme-dark",
    color: "#ffddaa"
  }
}, bs = {
  // Use readonly to prevent accidental mutations
  themeName: Pt(ke),
  theme: g(() => en[ke.value]),
  themes: en,
  toggleTheme() {
    ke.value = ke.value === ue.Light ? ue.Dark : ue.Light, window.localStorage.setItem(At, ke.value);
  },
  setTheme(e) {
    if (!(e in en)) {
      console.warn(`Attempted to set theme to invalid value: ${e}`);
      return;
    }
    ke.value = e, window.localStorage.setItem(At, e);
  }
};
function Cs() {
  return bs;
}
function ps(e) {
  const n = {
    icons: gs(),
    theme: ys(),
    defaults: hs()
  }, t = Oi(n, e);
  var a = qi(t);
  return a;
}
const Ss = { class: "text-capitalize" }, Ls = /* @__PURE__ */ we({
  __name: "ThemeToggle",
  props: {
    block: { type: Boolean, default: !1 },
    rounded: { type: [String, Number, Boolean], default: void 0 }
  },
  setup(e) {
    const n = e, { themeName: t, themes: a, toggleTheme: i } = Cs();
    return (l, r) => (U(), ee(mt, {
      onClick: X(i),
      block: n.block,
      rounded: n.rounded
    }, {
      prepend: B(() => [
        d(Tt, { type: "transition" }, {
          default: B(() => [
            (U(!0), et(ge, null, xa(X(a), (o, s) => (U(), et(ge, null, [
              X(t) === s ? (U(), ee(ce, {
                key: o.name,
                icon: o.icon,
                color: o.color
              }, null, 8, ["icon", "color"])) : Qe("", !0)
            ], 64))), 256))
          ]),
          _: 1
        })
      ]),
      default: B(() => [
        r[0] || (r[0] = Ne(" Theme: ")),
        De("span", Ss, Pe(X(t)), 1)
      ]),
      _: 1
    }, 8, ["onClick", "block", "rounded"]));
  }
}), Mi = /* @__PURE__ */ hi(Ls, [["__scopeId", "data-v-8049f6c5"]]), ws = k({
  color: String,
  inset: Boolean,
  length: [Number, String],
  opacity: [Number, String],
  thickness: [Number, String],
  vertical: Boolean,
  ...z(),
  ...de()
}, "VDivider"), xs = M()({
  name: "VDivider",
  props: ws(),
  setup(e, n) {
    let {
      attrs: t,
      slots: a
    } = n;
    const {
      themeClasses: i
    } = fe(e), {
      textColorClasses: l,
      textColorStyles: r
    } = it(Y(e, "color")), o = g(() => {
      const s = {};
      return e.length && (s[e.vertical ? "height" : "width"] = T(e.length)), e.thickness && (s[e.vertical ? "borderRightWidth" : "borderTopWidth"] = T(e.thickness)), s;
    });
    return D(() => {
      const s = d("hr", {
        class: [{
          "v-divider": !0,
          "v-divider--inset": e.inset,
          "v-divider--vertical": e.vertical
        }, i.value, l.value, e.class],
        style: [o.value, r.value, {
          "--v-border-opacity": e.opacity
        }, e.style],
        "aria-orientation": !t.role || t.role === "separator" ? e.vertical ? "vertical" : "horizontal" : void 0,
        role: `${t.role || "separator"}`
      }, null);
      return a.default ? d("div", {
        class: ["v-divider__wrapper", {
          "v-divider__wrapper--vertical": e.vertical,
          "v-divider__wrapper--inset": e.inset
        }]
      }, [s, d("div", {
        class: "v-divider__content"
      }, [a.default()]), s]) : s;
    }), {};
  }
}), ks = /* @__PURE__ */ we({
  __name: "UserMenuDropdown",
  props: {
    user: {}
  },
  emits: ["signOut"],
  setup(e, { emit: n }) {
    const t = n;
    return (a, i) => (U(), ee(cn, { elevation: 16 }, {
      prepend: B(() => [
        d(_t, {
          size: 85,
          color: "surface-variant"
        }, {
          default: B(() => [
            a.user.profilePictureUrl ? (U(), ee(Ge, {
              key: 0,
              src: a.user.profilePictureUrl,
              alt: a.user.userName
            }, null, 8, ["src", "alt"])) : (U(), ee(ce, { key: 1 }, {
              default: B(() => i[1] || (i[1] = [
                Ne("$account")
              ])),
              _: 1
            }))
          ]),
          _: 1
        })
      ]),
      item: B(() => [
        d(Ua, null, {
          default: B(() => [
            me(a.$slots, "before"),
            d(kn, null, {
              default: B(() => [
                Ne(Pe(a.user.userName), 1)
              ]),
              _: 1
            }),
            me(a.$slots, "afterTitle"),
            d(Da, null, {
              default: B(() => [
                Ne(Pe(a.user.email), 1)
              ]),
              _: 1
            }),
            me(a.$slots, "afterSubtitle")
          ]),
          _: 3
        })
      ]),
      actions: B(() => [
        d(X(Mi)),
        d(So),
        d(mt, {
          "prepend-icon": "$signOut",
          onClick: i[0] || (i[0] = (l) => t("signOut"))
        }, {
          default: B(() => i[2] || (i[2] = [
            Ne("Sign Out")
          ])),
          _: 1
        })
      ]),
      default: B(() => [
        d(xs)
      ]),
      _: 3
    }));
  }
}), $i = /* @__PURE__ */ we({
  __name: "UserMenu",
  props: {
    user: {}
  },
  emits: ["signOut"],
  setup(e, { emit: n }) {
    const t = n;
    return (a, i) => (U(), ee(mt, {
      icon: "",
      "aria-label": "User menu",
      "data-testid": "user-menu-button"
    }, {
      default: B(() => [
        d(_t, {
          size: "38px",
          alt: a.user.userName
        }, {
          default: B(() => [
            a.user.profilePictureThumbnailUrl ? (U(), ee(Ge, {
              key: 0,
              src: a.user.profilePictureThumbnailUrl,
              alt: a.user.userName
            }, null, 8, ["src", "alt"])) : (U(), ee(ce, {
              key: 1,
              icon: "$account"
            }))
          ]),
          _: 1
        }, 8, ["alt"]),
        d(Ti, {
          activator: "parent",
          transition: "slide-y-transition",
          "close-on-content-click": !1
        }, {
          default: B(() => [
            d(ks, {
              onSignOut: i[0] || (i[0] = (l) => t("signOut")),
              user: a.user
            }, {
              before: B(() => [
                me(a.$slots, "before")
              ]),
              afterTitle: B(() => [
                me(a.$slots, "afterTitle")
              ]),
              afterSubtitle: B(() => [
                me(a.$slots, "afterSubtitle")
              ]),
              _: 3
            }, 8, ["user"])
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
}), Ni = k({
  text: String,
  ...z(),
  ...te()
}, "VToolbarTitle"), Ri = M()({
  name: "VToolbarTitle",
  props: Ni(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    return D(() => {
      const a = !!(t.default || t.text || e.text);
      return d(e.tag, {
        class: ["v-toolbar-title", e.class],
        style: e.style
      }, {
        default: () => {
          var i;
          return [a && d("div", {
            class: "v-toolbar-title__placeholder"
          }, [t.text ? t.text() : e.text, (i = t.default) == null ? void 0 : i.call(t)])];
        }
      });
    }), {};
  }
}), _s = [null, "prominent", "default", "comfortable", "compact"], Hi = k({
  absolute: Boolean,
  collapse: Boolean,
  color: String,
  density: {
    type: String,
    default: "default",
    validator: (e) => _s.includes(e)
  },
  extended: Boolean,
  extensionHeight: {
    type: [Number, String],
    default: 48
  },
  flat: Boolean,
  floating: Boolean,
  height: {
    type: [Number, String],
    default: 64
  },
  image: String,
  title: String,
  ...dt(),
  ...z(),
  ...Dt(),
  ...Oe(),
  ...te({
    tag: "header"
  }),
  ...de()
}, "VToolbar"), ba = M()({
  name: "VToolbar",
  props: Hi(),
  setup(e, n) {
    var m;
    let {
      slots: t
    } = n;
    const {
      backgroundColorClasses: a,
      backgroundColorStyles: i
    } = Fe(Y(e, "color")), {
      borderClasses: l
    } = ft(e), {
      elevationClasses: r
    } = Ft(e), {
      roundedClasses: o
    } = Be(e), {
      themeClasses: s
    } = fe(e), {
      rtlClasses: u
    } = Ze(), c = H(!!(e.extended || (m = t.extension) != null && m.call(t))), f = g(() => parseInt(Number(e.height) + (e.density === "prominent" ? Number(e.height) : 0) - (e.density === "comfortable" ? 8 : 0) - (e.density === "compact" ? 16 : 0), 10)), v = g(() => c.value ? parseInt(Number(e.extensionHeight) + (e.density === "prominent" ? Number(e.extensionHeight) : 0) - (e.density === "comfortable" ? 4 : 0) - (e.density === "compact" ? 8 : 0), 10) : 0);
    return Ot({
      VBtn: {
        variant: "text"
      }
    }), D(() => {
      var L;
      const b = !!(e.title || t.title), y = !!(t.image || e.image), h = (L = t.extension) == null ? void 0 : L.call(t);
      return c.value = !!(e.extended || h), d(e.tag, {
        class: ["v-toolbar", {
          "v-toolbar--absolute": e.absolute,
          "v-toolbar--collapse": e.collapse,
          "v-toolbar--flat": e.flat,
          "v-toolbar--floating": e.floating,
          [`v-toolbar--density-${e.density}`]: !0
        }, a.value, l.value, r.value, o.value, s.value, u.value, e.class],
        style: [i.value, e.style]
      }, {
        default: () => [y && d("div", {
          key: "image",
          class: "v-toolbar__image"
        }, [t.image ? d(re, {
          key: "image-defaults",
          disabled: !e.image,
          defaults: {
            VImg: {
              cover: !0,
              src: e.image
            }
          }
        }, t.image) : d(Ge, {
          key: "image-img",
          cover: !0,
          src: e.image
        }, null)]), d(re, {
          defaults: {
            VTabs: {
              height: T(f.value)
            }
          }
        }, {
          default: () => {
            var p, x, _;
            return [d("div", {
              class: "v-toolbar__content",
              style: {
                height: T(f.value)
              }
            }, [t.prepend && d("div", {
              class: "v-toolbar__prepend"
            }, [(p = t.prepend) == null ? void 0 : p.call(t)]), b && d(Ri, {
              key: "title",
              text: e.title
            }, {
              text: t.title
            }), (x = t.default) == null ? void 0 : x.call(t), t.append && d("div", {
              class: "v-toolbar__append"
            }, [(_ = t.append) == null ? void 0 : _.call(t)])])];
          }
        }), d(re, {
          defaults: {
            VTabs: {
              height: T(v.value)
            }
          }
        }, {
          default: () => [d(No, null, {
            default: () => [c.value && d("div", {
              class: "v-toolbar__extension",
              style: {
                height: T(v.value)
              }
            }, [h])]
          })]
        })]
      });
    }), {
      contentHeight: f,
      extensionHeight: v
    };
  }
}), Vs = k({
  scrollTarget: {
    type: String
  },
  scrollThreshold: {
    type: [String, Number],
    default: 300
  }
}, "scroll");
function Es(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    canScroll: t
  } = n;
  let a = 0, i = 0;
  const l = j(null), r = H(0), o = H(0), s = H(0), u = H(!1), c = H(!1), f = g(() => Number(e.scrollThreshold)), v = g(() => nt((f.value - r.value) / f.value || 0)), m = () => {
    const b = l.value;
    if (!b || t && !t.value) return;
    a = r.value, r.value = "window" in b ? b.pageYOffset : b.scrollTop;
    const y = b instanceof Window ? document.documentElement.scrollHeight : b.scrollHeight;
    if (i !== y) {
      i = y;
      return;
    }
    c.value = r.value < a, s.value = Math.abs(r.value - f.value);
  };
  return R(c, () => {
    o.value = o.value || r.value;
  }), R(u, () => {
    o.value = 0;
  }), st(() => {
    R(() => e.scrollTarget, (b) => {
      var h;
      const y = b ? document.querySelector(b) : window;
      if (!y) {
        Ee(`Unable to locate element with identifier ${b}`);
        return;
      }
      y !== l.value && ((h = l.value) == null || h.removeEventListener("scroll", m), l.value = y, l.value.addEventListener("scroll", m, {
        passive: !0
      }));
    }, {
      immediate: !0
    });
  }), be(() => {
    var b;
    (b = l.value) == null || b.removeEventListener("scroll", m);
  }), t && R(t, m, {
    immediate: !0
  }), {
    scrollThreshold: f,
    currentScroll: r,
    currentThreshold: s,
    isScrollActive: u,
    scrollRatio: v,
    // required only for testing
    // probably can be removed
    // later (2 chars chlng)
    isScrollingUp: c,
    savedScroll: o
  };
}
function As() {
  const e = H(!1);
  return st(() => {
    window.requestAnimationFrame(() => {
      e.value = !0;
    });
  }), {
    ssrBootStyles: g(() => e.value ? void 0 : {
      transition: "none !important"
    }),
    isBooted: Pt(e)
  };
}
const Ps = k({
  scrollBehavior: String,
  modelValue: {
    type: Boolean,
    default: !0
  },
  location: {
    type: String,
    default: "top",
    validator: (e) => ["top", "bottom"].includes(e)
  },
  ...Hi(),
  ...pr(),
  ...Vs(),
  height: {
    type: [Number, String],
    default: 64
  }
}, "VAppBar"), Ts = M()({
  name: "VAppBar",
  props: Ps(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, n) {
    let {
      slots: t
    } = n;
    const a = j(), i = ct(e, "modelValue"), l = g(() => {
      var x;
      const p = new Set(((x = e.scrollBehavior) == null ? void 0 : x.split(" ")) ?? []);
      return {
        hide: p.has("hide"),
        fullyHide: p.has("fully-hide"),
        inverted: p.has("inverted"),
        collapse: p.has("collapse"),
        elevate: p.has("elevate"),
        fadeImage: p.has("fade-image")
        // shrink: behavior.has('shrink'),
      };
    }), r = g(() => {
      const p = l.value;
      return p.hide || p.fullyHide || p.inverted || p.collapse || p.elevate || p.fadeImage || // behavior.shrink ||
      !i.value;
    }), {
      currentScroll: o,
      scrollThreshold: s,
      isScrollingUp: u,
      scrollRatio: c
    } = Es(e, {
      canScroll: r
    }), f = g(() => l.value.hide || l.value.fullyHide), v = g(() => e.collapse || l.value.collapse && (l.value.inverted ? c.value > 0 : c.value === 0)), m = g(() => e.flat || l.value.fullyHide && !i.value || l.value.elevate && (l.value.inverted ? o.value > 0 : o.value === 0)), b = g(() => l.value.fadeImage ? l.value.inverted ? 1 - c.value : c.value : void 0), y = g(() => {
      var _, O;
      if (l.value.hide && l.value.inverted) return 0;
      const p = ((_ = a.value) == null ? void 0 : _.contentHeight) ?? 0, x = ((O = a.value) == null ? void 0 : O.extensionHeight) ?? 0;
      return f.value ? o.value < s.value || l.value.fullyHide ? p + x : p : p + x;
    });
    ut(g(() => !!e.scrollBehavior), () => {
      Te(() => {
        f.value ? l.value.inverted ? i.value = o.value > s.value : i.value = u.value || o.value < s.value : i.value = !0;
      });
    });
    const {
      ssrBootStyles: h
    } = As(), {
      layoutItemStyles: L
    } = Sr({
      id: e.name,
      order: g(() => parseInt(e.order, 10)),
      position: Y(e, "location"),
      layoutSize: y,
      elementSize: H(void 0),
      active: i,
      absolute: Y(e, "absolute")
    });
    return D(() => {
      const p = ba.filterProps(e);
      return d(ba, Z({
        ref: a,
        class: ["v-app-bar", {
          "v-app-bar--bottom": e.location === "bottom"
        }, e.class],
        style: [{
          ...L.value,
          "--v-toolbar-image-opacity": b.value,
          height: void 0,
          ...h.value
        }, e.style]
      }, p, {
        collapse: v.value,
        flat: m.value
      }), t);
    }), {};
  }
}), Is = k({
  ...Si({
    icon: "$menu",
    variant: "text"
  })
}, "VAppBarNavIcon"), Os = M()({
  name: "VAppBarNavIcon",
  props: Is(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    return D(() => d(mt, Z(e, {
      class: ["v-app-bar-nav-icon"]
    }), t)), {};
  }
}), Bs = M()({
  name: "VAppBarTitle",
  props: Ni(),
  setup(e, n) {
    let {
      slots: t
    } = n;
    return D(() => d(Ri, Z(e, {
      class: "v-app-bar-title"
    }), t)), {};
  }
}), Ms = ["src"], $s = {
  "data-testid": "app-title",
  class: "text-body-2 opacity-70"
}, Ns = { "data-testid": "page-title" }, Rs = /* @__PURE__ */ we({
  __name: "NavBar",
  props: {
    session: {},
    logo: {},
    appTitle: {},
    pageTitle: {},
    apps: {}
  },
  emits: ["signOut"],
  setup(e, { emit: n }) {
    const t = e, a = n;
    return (i, l) => (U(), ee(Ts, {
      class: "justify-start px-1",
      floating: !1,
      name: "header"
    }, {
      prepend: B(() => [
        d(Os, {
          onClick: X(fs)().toggleMenu,
          "aria-label": "Menu"
        }, null, 8, ["onClick"])
      ]),
      append: B(() => {
        var r;
        return [
          me(i.$slots, "append"),
          ((r = t.apps) == null ? void 0 : r.length) > 1 ? (U(), ee(X(Ii), {
            key: 0,
            class: "mr-1",
            apps: t.apps
          }, null, 8, ["apps"])) : Qe("", !0),
          i.session ? me(i.$slots, "UserMenu", { key: 1 }, () => [
            d(X($i), {
              user: i.session,
              onSignOut: l[0] || (l[0] = (o) => a("signOut"))
            }, null, 8, ["user"])
          ]) : Qe("", !0)
        ];
      }),
      default: B(() => [
        t.logo ? (U(), et("img", {
          key: 0,
          src: t.logo,
          class: "logo",
          alt: "App Logo",
          "aria-label": "Logo"
        }, null, 8, Ms)) : Qe("", !0),
        d(Bs, null, {
          default: B(() => [
            De("p", $s, Pe(t.appTitle), 1),
            De("span", Ns, Pe(t.pageTitle), 1)
          ]),
          _: 1
        }),
        me(i.$slots, "default")
      ]),
      _: 3
    }));
  }
});
function js(e) {
  var n = ps(e == null ? void 0 : e.vuetify);
  return {
    install: (t) => {
      t.component("SfiAppLoading", Pr), t.component("SfiAppSwitcher", Ii), t.component("SfiNavBar", Rs), t.component("SfiThemeToggle", Mi), t.component("SfiUserMenu", $i), t.use(n);
    }
  };
}
export {
  Pr as AppLoading,
  Ii as AppSwitcher,
  Rs as NavBar,
  ue as Theme,
  Mi as ThemeToggle,
  $i as UserMenu,
  js as createSimplifiComponents,
  ps as createSimplifiVuetify,
  zs as initTheme,
  fs as useNav,
  Cs as useTheme
};
